<template>
    <div class="mindmap-home" :class="{ 'mindmap-home-unlogin': !isLogin && currentView !== 'gallery', 'mindmap-home-gallery': currentView === 'gallery' }">
        <div class="nav-menu" v-show="showNavMenu">
            <div class="nav-title">{{ profile.name }}</div>
            <div class="nav-title">{{ $t("mindmap.fluidRelayUsage") }}{{ currentOpenFRUsage }}/{{ maxOpenFRUsage }}</div>
            <div class="nav-item" @click="logout">{{ $t("mindmap.mindmapHome.logout") }}</div>
        </div>
        <div class="title-menu" v-show="showTitleMenu">
            <div class="title-item" @click="setMyMindMapView()">{{ $t("mindmap.mindmapHome.myMindMap") }}</div>
            <div v-if="canUsePublicDisplay" class="title-item" @click="setView('public')">{{ $t("mindmap.publicDisplay") }}</div>
            <div class="title-item" @click="setView('recent')">{{ $t("mindmap.recentClick") }}</div>
        </div>


        <div :class="showSideAddBox ? 'side-add-box' : 'add-box'" v-show="showAddBox || showSideAddBox">
            <div @click="createMindMap()" class="add-btn">{{
        $t("mindmap.mindmapHome.addFile") }}</div>

            <div @click="createMindMap({ coworkEditMode: true })" class="add-btn">{{
        $t("mindmap.mindmapHome.addCoworkMindMap") }}</div>
            <div @click="openCollectNormalModal()" class="add-btn">
                {{ $t("mindmap.mindmapHome.addCollectNormal") }}
            </div>
            <div @click="createMindMapCollect()" class="add-btn">
                {{ $t("mindmap.mindmapHome.addMindCollect") }}
            </div>
        </div>
        <div class="search-box" v-show="showSearchBox">
            <!--搜尋-->
            <div class="search-wrap" v-if="currentView == 'list' || currentView == 'grid'">
                <div class="back-btn" @click="closeSearchBox()">
                    <svg-icon icon-class="arrow-pre" />
                </div>

                <label class="search-bar">
                    <input :placeholder="$t('mindmap.mindmapHome.search')" v-model="search" />
                    <div class="delete-btn" v-show="search.length !== 0" @click="resetSearch()">
                        <svg-icon icon-class="close" />
                    </div>
                    <button type="submit" class="search-btn" @click="searchMindMaps()" :disabled="search.length == 0">
                        <svg-icon icon-class="search" class="search-icon" />
                    </button>
                </label>
            </div>
            <!--搜尋End-->
        </div>
        <div class="actions" v-show="showActionMenu"
            :style="{ left: actionMenuPos.x + 'px', top: actionMenuPos.y + 'px' }">
            <div class="action-item" @click="openShareLinkBox(currentMindMap)">{{ $t("mindmap.mindmapHome.share") }}
            </div>
            <div class="action-item" @click="openComfirmDelete(currentMindMap)">{{ $t("mindmap.mindmapHome.delete") }}
            </div>
            <div class="action-item" @click="renameMindMap()">{{ $t("mindmap.mindmapHome.rename") }}</div>
            <div class="action-item" @click="openDetailInfo()">{{ $t("mindmap.mindmapHome.detailInfo") }}</div>
            <div class="action-item" @click="copyMindMap(currentMindMap)">{{ $t("mindmap.mindmapHome.copy") }}</div>
            <div class="action-item" @click="openMoveToFolder(currentMindMap)">{{ $t("mindmap.mindmapHome.moveToFolder") }}</div>
            <div class="action-item" @click="moveOutFolder(currentMindMap)" v-if="currentMindMap.collectId">{{ $t("mindmap.mindmapHome.moveOutFolder") }}</div>
            <div class="action-item" @click="createMindCollectFromTemplate(currentMindMap)">{{ $t("mindmap.mindmapHome.createMindMapTask") }}</div>

        </div>
        <div class="actions" v-show="showCollectActionMenu"
            :style="{ left: actionMenuPos.x + 'px', top: actionMenuPos.y + 'px' }">
            <div class="action-item" @click="openMindCollectSetting()">{{
        $t("mindmap.mindmapHome.mindCollect.colletSetting") }}</div>
            <div class="action-item" @click="openComfirmDeleteCollect()">{{ $t('mindmap.mindmapHome.delete') }}</div>

        </div>
        <div class="actions" v-show="showCollectNormalActionMenu"
            :style="{ left: actionMenuPos.x + 'px', top: actionMenuPos.y + 'px' }">
            <div class="action-item" @click="openMindCollectNormalSetting()">{{
        $t("mindmap.mindmapHome.mindCollectNormal.colletSetting") }}</div>
            <div class="action-item" @click="openComfirmDeleteCollectNormal()">{{ $t('mindmap.mindmapHome.delete') }}
            </div>

        </div>
        <div class="actions" v-show="showPublicActionMenu"
            :style="{ left: actionMenuPos.x + 'px', top: actionMenuPos.y + 'px' }">
            <div class="action-item" @click="confirmDeletePublicMindMap()">{{ $t('mindmap.mindmapHome.delete') }}</div>
        </div>
        <!---MindCollect--->
        <div v-show="showUpdateMindCollectSetting && !showQRCodeCard" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"> <svg-icon iconClass="close" @click="confirmToUpdateMindCollect()"></svg-icon>
                </div>
                <div class="shareCard-title">{{ $t('mindmap.mindmapHome.mindCollect.updateSetting') }}</div>
                <div class="shareCard-content">
                    <div class="rename-wrap">
                        <label class="rename-bar">
                            <input :placeholder="currentMindCollectName" v-model="renameMindCollectVal"
                                maxlength="20" />
                            <div class="delete-btn" v-show="renameMindCollectVal.length !== 0"
                                @click="resetMindCollectName()">
                                <svg-icon icon-class="close" />
                            </div>
                        </label>
                    </div>
                </div>
                <div class="flex-container">
                    <div class="flex-item">{{ $t("mindmap.mindmapHome.mindCollect.openSummitTitle") }}</div>
                    <label class="switch flex-item">
                        <input type="checkbox" v-model="isMindCollectSubmitOpen">
                        <span class="slider round"></span>
                    </label>

                </div>

                <div class="flex-container">

                    <div class="flex-item">{{ $t("mindmap.mindmapHome.mindCollect.allowViewTitle") }}</div>
                    <label class="switch flex-item">
                        <input type="checkbox" v-model="isMindCollectAllowView">
                        <span class="slider round"></span>
                    </label>
                </div>
                <div class="url-wrap url-wrap-small"><span class="url-title">URL：</span>{{ shortURLHost }}<span
                        class="short-url">{{
        currentMindMapURL }}
                    </span>
                    <span class="copy-btn" @click="copyShortUrl()"><svg-icon icon-class="copy" /></span>
                    <span class="copy-btn" @click="openQRCode(shortURLHost + currentMindMapURL, currentMindMapURL)"><svg-icon icon-class="qrcode-new" /></span>
                    <span class="copy-btn" @click="refreshClipCode(currentMindMap)" :title="$t('mindmap.mindmapHome.refreshClipCode')" style="display: none"><svg-icon iconClass="refresh" /></span>
                </div>
            </div>
        </div>
        <div v-show="showMindCollectSetting && !showQRCodeCard" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"> <svg-icon iconClass="close" @click="showMindCollectSetting = false"></svg-icon>
                </div>
                <div class="shareCard-title">{{ $t("mindmap.mindmapHome.mindCollect.createTitleSetting") }}</div>
                <div class="shareCard-content">
                    <div class="rename-wrap">
                        <label class="rename-bar">
                            <input :placeholder="currentMindCollectName" v-model="renameMindCollectVal"
                                maxlength="20" />
                            <div class="delete-btn" v-show="renameMindCollectVal.length !== 0"
                                @click="resetMindCollectName()">
                                <svg-icon icon-class="close" />
                            </div>
                        </label>
                    </div>
                </div>
                <div class="flex-container">
                    <div class="flex-item">{{ $t("mindmap.mindmapHome.mindCollect.openSummitTitle") }}</div>
                    <label class="switch flex-item">
                        <input type="checkbox" v-model="isMindCollectSubmitOpen">
                        <span class="slider round"></span>
                    </label>

                </div>
                <div class="flex-container">

                    <div class="flex-item">{{ $t("mindmap.mindmapHome.mindCollect.allowViewTitle") }}</div>
                    <label class="switch flex-item">
                        <input type="checkbox" v-model="isMindCollectAllowView">
                        <span class="slider round"></span>
                    </label>
                </div>
                
                <!-- Tips 提示區塊 -->
                <div class="tips-container">
                    <div class="tips-text">{{ $t("mindmap.mindmapHome.mindCollect.templateTips") }}</div>
                </div>
                
                <div class="btn-wrap">
                    <div class="save-btn btn-full" @click="confirmToCreateMindCollect()">{{ $t("mindmap.確定") }}</div>
                    <div class="temp-btn gray-btn" @click="showMindCollectSetting = false">{{ $t("mindmap.取消") }}</div>

                </div>


            </div>

        </div>

        <!---MindCollectNormal--->
        <div v-show="showCollectNormalModal" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"> <svg-icon iconClass="close" @click="showCollectNormalModal = false"></svg-icon>
                </div>
                <div class="shareCard-title">{{ $t("mindmap.mindmapHome.mindCollectNormal.createTitleSetting") }}</div>
                <div class="shareCard-content">
                    <div class="rename-wrap">
                        <label class="rename-bar">
                            <input :placeholder="currentMindCollectNormalName" v-model="renameMindCollectNormalVal"
                                maxlength="20" />
                            <div class="delete-btn" v-show="renameMindCollectNormalVal.length !== 0"
                                @click="resetMindCollectNormalName()">
                                <svg-icon icon-class="close" />
                            </div>
                        </label>
                    </div>
                </div>

                <div class="btn-wrap">
                    <div class="save-btn btn-full" @click="confirmToCreateMindCollectNormal()">{{ $t("mindmap.確定") }}
                    </div>
                    <div class="temp-btn gray-btn" @click="showCollectNormalModal = false">{{ $t("mindmap.取消") }}</div>
                </div>
            </div>
        </div>

        <div v-show="showUpdateMindCollectNormalSetting && !showQRCodeCard" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"> <svg-icon iconClass="close"
                        @click="confirmToUpdateMindCollectNormal()"></svg-icon>
                </div>
                <div class="shareCard-title">{{ $t('mindmap.mindmapHome.mindCollectNormal.updateSetting') }}</div>
                <div class="shareCard-content">
                    <div class="rename-wrap">
                        <label class="rename-bar">
                            <input :placeholder="currentMindCollectNormalName" v-model="renameMindCollectNormalVal"
                                maxlength="20" />
                            <div class="delete-btn" v-show="renameMindCollectNormalVal.length !== 0"
                                @click="resetMindCollectNormalName()">
                                <svg-icon icon-class="close" />
                            </div>
                        </label>
                    </div>
                </div>

                <div class="url-wrap url-wrap-small"><span class="url-title">URL：</span>{{ shortURLHost }}<span
                        class="short-url">{{
        currentMindMapURL }}
                    </span>
                    <span class="copy-btn" @click="copyShortUrl()"><svg-icon icon-class="copy" /></span>
                    <span class="copy-btn" @click="openQRCode(shortURLHost + currentMindMapURL, currentMindMapURL)"><svg-icon icon-class="qrcode-new" /></span>
                    <span class="copy-btn" @click="refreshClipCode(currentMindMap)" :title="$t('mindmap.mindmapHome.refreshClipCode')" style="display: none"><svg-icon iconClass="refresh" /></span>
                </div>
            </div>
        </div>

        <div v-show="showRenameBox" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"> <svg-icon iconClass="close" @click="closeRenameBox()"></svg-icon></div>
                <div class="shareCard-title">{{ $t("mindmap.mindmapHome.renameFile") }}</div>

                <div class="rename-wrap">
                    <label class="rename-bar">
                        <input :placeholder="currentMindMap.mindmapName" v-model="renameVal" maxlength="20" />
                        <div class="delete-btn" v-show="renameVal.length !== 0" @click="resetRename()">
                            <svg-icon icon-class="close" />
                        </div>
                    </label>
                </div>

                <div v-show="renameVal.length !== 0 && renameVal !== currentMindMap.mindmapName" class="save-btn"
                    @click="saveRename()">
                    {{ $t("mindmap.mindmapHome.save") }}</div>
            </div>
        </div>
        <!-- 資料夾清單彈窗 -->
        <div v-show="showMoveToFolderModal" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"> <svg-icon iconClass="close" @click="closeMoveToFolderModal()"></svg-icon></div>
                <div class="shareCard-title">{{ currentMindMap.mindmapName }}</div>
                <div class="shareCard-title">{{ $t("mindmap.mindmapHome.moveToFolder") }}</div>
                <div class="shareCard-content">
                    <div class="folder-list">
                        <div v-if="folderList.length === 0" class="no-folder">{{ $t("mindmap.mindmapHome.noFolder") }}</div>
                        <div v-else v-for="folder in folderList" :key="folder.id" class="folder-item"
                            :class="{ 'folder-selected': selectedFolderId === folder.id }" @click="selectFolder(folder)">
                            <svg-icon icon-class="folder" class="folder-icon" />
                            <span class="folder-name">{{ folder.mindCollectName }}</span>
                        </div>
                    </div>
                </div>
                <div class="btn-wrap">
                    <div class="save-btn btn-full" v-show="selectedFolderId" @click="confirmMoveToFolder()">{{
        $t("mindmap.確定") }}</div>
                    <div class="temp-btn gray-btn" @click="closeMoveToFolderModal()">{{ $t("mindmap.取消") }}</div>
                </div>
            </div>
        </div>

        <div v-show="showShareLinkBox && !showQRCodeCard" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"> <svg-icon iconClass="close" @click="closeShareLinkBox()"></svg-icon></div>
                <div class="shareCard-title">{{ currentMindMap.mindmapName }}</div>


                <div v-show="currentMindMap.openCowork && currentMindMapURL !== ''" class="url-wrap"><span
                        class="url-title">URL：</span>{{ shortURLHost }}<span class="short-url">{{
        currentMindMapURL }}</span>
                    <span class="copy-btn" @click="copyShortUrl()"><svg-icon icon-class="copy" /></span>
                    <span class="copy-btn" @click="openQRCode(shortURLHost + currentMindMapURL, currentMindMapURL)"><svg-icon icon-class="qrcode-new" /></span>
                    <span class="copy-btn" @click="refreshClipCode(currentMindMap)" :title="$t('mindmap.mindmapHome.refreshClipCode')" style="display: none"><svg-icon iconClass="refresh" /></span>
                </div>
                <div class="cowork-mode">
                    <div class="cowork-mode-title">{{ $t("mindmap.mindmapHome.haveLinkCanDo") }}</div>
                    <SelectMenu :category="coworkModeCate"
                        :defaultSelect="$t('mindmap.mindmapHome.coworkModeNoteText.viewLongVer')" ref="coworkModeSelect"
                        class="cowork-mode-select" />
                    <div v-show="currentMindMap.openCowork && showSaveCoworkBtn" class="save-btn"
                        @click="saveCoworkMode()">{{ $t("mindmap.mindmapHome.save") }}</div>
                    <div v-show="currentMindMap.openCowork" class="save-btn gray-btn" @click="closeOpenCowork()">
                        {{ $t("mindmap.mindmapHome.closeShare") }}
                    </div>
                    <div v-show="!currentMindMap.openCowork" @click="setOpenCowork()" class="save-btn">
                        {{ $t("mindmap.mindmapHome.publishShare") }}</div>
                </div>


            </div>
        </div>
        <div v-show="showComfirmDelete" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"> <svg-icon iconClass="close" @click="closeComfirmDelete()"></svg-icon></div>
                <div class="shareCard-title">{{ $t("mindmap.mindmapHome.confirmDelete") }}{{ currentMindMap.mindmapName }}
                </div>
                <div>{{ $t("mindmap.mindmapHome.comfirmDelete") }}</div>
                <div class="temp-btn danger-btn" @click="deleteMindMap(currentMindMap)">{{ $t("mindmap.確定") }}</div>
                <div class="temp-btn gray-btn" @click="closeComfirmDelete()">{{ $t("mindmap.取消") }}</div>
            </div>
        </div>

        <div v-show="showComfirmDeleteCollect" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"> <svg-icon iconClass="close" @click="closeComfirmDeleteCollect()"></svg-icon>
                </div>
                <div class="shareCard-title">{{ $t("mindmap.mindmapHome.confirmDelete") }}{{
        currentMindMap.mindCollectName }}</div>
                <div>{{ $t("mindmap.mindmapHome.mindCollect.confirmDeleteCollectText") }} </div>
                <div class="temp-btn danger-btn" @click="deleteMindCollectAllContent(currentMindMap)">
                    {{ $t("mindmap.確定") }}</div>
                <div class="temp-btn gray-btn" @click="closeComfirmDeleteCollect()">{{ $t("mindmap.取消") }}</div>
            </div>
        </div>

        <div v-show="showComfirmDeleteCollectNormal" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"> <svg-icon iconClass="close"
                        @click="closeComfirmDeleteCollectNormal()"></svg-icon>
                </div>
                <div class="shareCard-title">{{ $t("mindmap.mindmapHome.confirmDelete") }}{{
        currentMindMap.mindCollectName }}</div>
                <div>{{ $t("mindmap.mindmapHome.mindCollectNormal.confirmDeleteCollectText") }} </div>
                <div class="temp-btn danger-btn" @click="deleteMindCollectAllContent(currentMindMap)">
                    {{ $t("mindmap.確定") }}</div>
                <div class="temp-btn gray-btn" @click="closeComfirmDeleteCollectNormal()">{{ $t("mindmap.取消") }}</div>
            </div>
        </div>

        <div v-show="showConfirmDeletePublic" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"><svg-icon iconClass="close" @click="showConfirmDeletePublic = false"></svg-icon></div>
                <div class="shareCard-title">{{ currentPublicItem?.title }}</div>
                <div>{{ $t("mindmap.publicDeleteConfirm") }}</div>
                <div class="temp-btn danger-btn" @click="doDeletePublicMindMap()">{{ $t("mindmap.確定") }}</div>
                <div class="temp-btn gray-btn" @click="showConfirmDeletePublic = false">{{ $t("mindmap.取消") }}</div>
            </div>
        </div>


        <div v-show="showDetailInfo" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"> <svg-icon iconClass="close" @click="closeDetailInfo()"></svg-icon></div>
                <div class="shareCard-title">{{ currentMindMap.mindmapName }}</div>
                <div class="detail-info">
                    <!-- {{ currentMindMap }} -->
                    <div v-if="currentMindMap.mindmapCreator">{{ $t("mindmap.mindmapHome.mindmapCreator") }}：{{
        currentMindMap.mindmapCreator.name }}</div>
                    <div v-if="currentMindMap.mindmapCreator">{{ $t("mindmap.mindmapHome.createTime") }}：{{
        getTime(currentMindMap.createTime) }}</div>
                    <div v-if="currentMindMap.mindmapEditor">{{ $t("mindmap.mindmapHome.mindmapEditor") }}：{{
        currentMindMap.mindmapEditor.name }}</div>
                    <div v-if="currentMindMap.mindmapEditor">{{ $t("mindmap.mindmapHome.updateTime") }}：{{
        getTime(currentMindMap.updateTime) }}</div>
                    <div>{{ $t("mindmap.mindmapHome.shareShort") }}：{{ currentMindMap.openCowork ?
        $t("mindmap.mindmapHome.true") : $t("mindmap.mindmapHome.false") }}</div>
                    <div v-if="currentMindMap.openCowork">{{ $t("mindmap.mindmapHome.coworkMode") }}：{{
        currentMindMap.coworkMode === 'view' ? $t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") :
            $t("mindmap.mindmapHome.coworkModeNoteText.editLongVer") }}</div>
                </div>

            </div>
        </div>
        <div class="flex-bar" :class="{ 'flex-bar-gallery': currentView === 'gallery' }">
            <div class="left">
                <div class="title" @click="setView('gallery')" style="cursor:pointer;">
                    <svg-icon iconClass="hi-mind"></svg-icon>
                    <span class="title-text">{{ $t("mindmap.productName") }}</span>
                </div>
            </div>
            <!-- Gallery 視圖中間的簡碼輸入框 -->
            <div class="navbar-center" v-if="currentView === 'gallery' || !isLogin">
                <label class="search-bar navbar-shorturl-bar">
                    <input :placeholder="$t('mindmap.mindmapHome.enterShortUrl')" v-model="shortUrlInput"
                        autocomplete="off" data-form-type="search" spellcheck="false" maxlength="10"
                        @keyup.enter="handleShortUrlEnter" />
                    <div class="delete-btn" v-show="shortUrlInput.length !== 0" @click="resetShortUrlInput()">
                        <svg-icon icon-class="close" />
                    </div>
                    <button type="submit" class="search-btn" @click="openMindMapByShortUrl()"
                        :disabled="shortUrlInput.length == 0">
                        <svg-icon icon-class="arrow-next" class="search-icon" />
                    </button>
                </label>
            </div>
            <div class="right gallery-nav-right" v-if="!isLogin">
                <div @click="loginTMID()" class="login-btn">{{ $t("mindmap.mindmapHome.login") }}</div>
            </div>
            <!-- 已登入 + gallery 視圖：點頭像回到我的文件 -->
            <div class="right gallery-nav-right" v-else-if="currentView === 'gallery'">
                <div class="my-mindmap-btn" @click="setMyMindMapView()">
                    {{ $t('mindmap.mindmapHome.myMindMapBtn') }}
                    <img class="avatar" :src="profile.picture" alt="">
                </div>
            </div>
            <div class="right" v-else :class="{ 'recent-right': currentView == 'recent' }">
                <!--搜尋-->
                <div class="search-wrap" v-if="currentView == 'list' || currentView == 'grid'">
                    <label class="search-bar">
                        <input :placeholder="$t('mindmap.mindmapHome.search')" v-model="search" />
                        <div class="delete-btn" v-show="search.length !== 0" @click="resetSearch()">
                            <svg-icon icon-class="close" />
                        </div>
                        <button type="submit" class="search-btn" @click="searchMindMaps()"
                            :disabled="search.length == 0">
                            <svg-icon icon-class="search" class="search-icon" />
                        </button>
                    </label>
                </div>
                <!--搜尋End-->

                <div class="view-btn search-btn-mid" v-if="currentView == 'list' || currentView == 'grid'"
                    @click="openSearchBox()">
                    <svg-icon icon-class="search" class="search-icon" />
                </div>

                <div class="view-btn" v-if="currentView == 'list' || currentView == 'grid'"
                    :class="{ 'active-btn': currentView == 'list' }" @click="setView('list')">
                    <svg-icon icon-class="list" />
                </div>
                <div class="view-btn" v-if="currentView == 'list' || currentView == 'grid'"
                    :class="{ 'active-btn': currentView == 'grid' }" @click="setView('grid')">
                    <svg-icon icon-class="grid" />
                </div>

                <!--中螢幕新增按鈕-->
                <div class="view-btn add-btn-mid" v-if="currentView == 'list' || currentView == 'grid' || currentView == 'public'"
                    :class="{ 'active-btn': showAddBox }" @click="openAddBox()">
                    <svg-icon icon-class="add" />
                </div>
                <!--中螢幕新增按鈕End-->
                
                <!-- 篩選按鈕 (只在最近點閱頁面顯示) -->
                <div class="filter-btn-header" v-if="currentView === 'recent'" @click="toggleFavoriteFilter" 
                     :class="{ 'filter-active': showOnlyFavorites }" >
                    <svg-icon icon-class="star-fill" class="filter-star-icon" />
                </div>
                
                <div class="avatar-wrap" @click="OpenAvatarMenu()"><img class="avatar" :src="profile.picture" alt="">
                </div>
            </div>
        </div>
        <!-- Gallery 視圖：登入/未登入都可見 -->
        <div v-show="currentView === 'gallery'" class="gallery-wrapper">
            <!-- Hero 區 -->
            <div class="gallery-hero" @mousemove="onHeroMouseMove">
                <!-- 動畫色塊 -->
                <div class="hero-blob hero-blob-coral"></div>
                <div class="hero-blob hero-blob-violet"></div>
                <div class="hero-blob hero-blob-mint"></div>

                <!-- 浮動節點 -->
                <div v-for="(node, i) in heroNodes" :key="i"
                     class="hero-node"
                     :class="'hero-node-' + node.colorClass"
                     :style="getNodeStyle(node, i)">
                    <svg-icon :icon-class="node.icon" />
                </div>

                <!-- 連線 SVG -->
                <svg class="hero-lines" aria-hidden="true">
                    <line v-for="(node, i) in heroNodes" :key="i"
                        x1="50%" y1="50%"
                        :x2="node.x + '%'" :y2="node.y + '%'"
                        stroke-dasharray="4 4"/>
                </svg>

                <div class="gallery-hero-inner">
                    <div class="hero-stats-badge">
                        <span class="hero-badge-dot"></span>
                        {{ galleryTotal > 0 ? $t('mindmap.mindmapHome.galleryHeroStats', { count: galleryTotal.toLocaleString() }) : '...' }}
                    </div>
                    <h1 class="gallery-hero-title" v-html="heroTitleHtml"></h1>
                    <p class="gallery-hero-sub">{{ $t("mindmap.mindmapHome.heroSub") }}</p>
                    <div class="gallery-hero-cta">
                        <button v-if="!isLogin" class="hero-login-btn" @click="goToPlayground()">
                            {{ $t('mindmap.mindmapHome.galleryLoginBtn') }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- 經典範例參考區 -->
            <!-- <div class="gallery-templates">
                <div class="gallery-templates-header">
                    <h2 class="gallery-templates-title" v-html="$t('mindmap.mindmapHome.galleryTemplatesTitle', { highlight: `<span class=\'title-highlight\'>${$t('mindmap.mindmapHome.galleryTemplatesHighlight')}</span>` })"></h2>
                    <p class="gallery-templates-sub">{{ $t('mindmap.mindmapHome.galleryTemplatesSub') }}</p>
                </div>
                <div class="gallery-templates-rail">
                    <div class="gallery-template-card"
                         v-for="(t, i) in templateCards" :key="t.id"
                         :style="{ '--card-color': t.color }">
                        <div class="template-card-thumb">
                            <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" class="mini-mindmap-svg">
                                <line v-for="(s, si) in t.satellites" :key="'l'+si"
                                    x1="50" y1="50" :x2="s[0]" :y2="s[1]"
                                    stroke="rgba(255,255,255,0.7)" stroke-width="1.5"/>
                                <circle v-for="(s, si) in t.satellites" :key="'c'+si"
                                    :cx="s[0]" :cy="s[1]" r="5"
                                    fill="white" fill-opacity="0.85"/>
                                <circle cx="50" cy="50" r="8" fill="white"/>
                            </svg>
                            <span class="template-card-num">0{{ i + 1 }}</span>
                        </div>
                        <div class="template-card-info">
                            <div class="template-card-title-row">
                                <svg-icon :icon-class="t.icon" class="template-icon" />
                                <span>{{ t.title }}</span>
                            </div>
                            <div class="template-card-sub">{{ t.sub }}</div>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- Gallery 內容區 -->
            <div class="gallery-content">
                <div class="gallery-toolbar">
                    <div class="gallery-section-title-wrap">
                        <div class="gallery-section-title-row">
                            <svg class="gallery-title-flame" viewBox="0 0 60 74" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                <path d="M30 72 C18 72 8 62 8 50 C8 38 14 28 20 20 C16 24 13 30 14 38 C11 32 12 22 18 14 C22 8 26 4 30 2 C34 4 38 8 42 14 C48 22 49 32 46 38 C47 30 44 24 40 20 C46 28 52 38 52 50 C52 62 42 72 30 72Z" fill="#D95F52"/>
                                <path d="M30 38 C24 42 20 48 20 55 C20 63 24 70 30 70 C36 70 40 63 40 55 C40 48 36 42 30 38Z" fill="#F6C12A"/>
                            </svg>
                            <span class="gallery-section-title">{{ $t('mindmap.mindmapHome.galleryExploreTitle') }}</span>
                        </div>
                        <p class="gallery-section-subtitle">{{ $t('mindmap.mindmapHome.gallerySubtitle') }}</p>
                    </div>
                    <label class="search-bar gallery-search-bar">
                        <input :placeholder="$t('mindmap.mindmapHome.gallerySearchPlaceholder')" v-model="gallerySearch"
                            @keyup.enter="searchGallery()" />
                        <div class="delete-btn" v-show="gallerySearch.length !== 0" @click="clearGallerySearch()">
                            <svg-icon icon-class="close" />
                        </div>
                        <button class="search-btn" @click="searchGallery()">
                            <svg-icon icon-class="search" class="search-icon" />
                        </button>
                    </label>
                </div>

                <div class="gallery-grid" v-if="galleryItems.length > 0">
                    <div class="gallery-card" v-for="(item, idx) in galleryItems" :key="item.id"
                        @click="openPublicMindMap(item)">
                        <div class="gallery-card-img" v-lazy-background="getHistoryImg(item.snapshotUrl)">
                            <div class="gallery-card-views-badge">
                                <svg-icon icon-class="eye" class="view-icon" />
                                <span>{{ formatViewCount(item.viewCount || 0) }}</span>
                            </div>
                        </div>
                        <div class="gallery-card-info" :style="{ background: cardColorSeq[idx] || '#fff' }">
                            <div class="gallery-card-meta">
                                <span class="gallery-card-author">@ {{ getPublisherName(item.publisher) }}</span>
                                <span class="gallery-card-dot">·</span>
                                <span class="gallery-card-date">{{ item.publishTime ? new Date(item.publishTime * 1000).toLocaleDateString() : '' }}</span>
                            </div>
                            <h5 class="gallery-card-title">{{ item.title }}</h5>
                        </div>
                    </div>
                </div>
                <div v-else-if="isGalleryLoading" class="gallery-status">{{ $t('mindmap.mindmapHome.galleryLoading') }}</div>
                <div v-else class="gallery-status">{{ $t('mindmap.mindmapHome.galleryEmpty') }}</div>

                <div class="gallery-load-more" v-if="galleryHasMore && !isGalleryLoading">
                    <div class="load-more-btn" @click="loadMoreGallery()">{{ $t('mindmap.mindmapHome.galleryLoadMore') }}</div>
                </div>
            </div>

            <!-- Footer copyright -->
            <div class="gallery-footer">
                <span>{{ $t('mindmap.copyright') }}</span>
            </div>
        </div>

        <div v-show="isLogin && currentView !== 'gallery'" class="mid-title-btn" @click="openTitleMenu()"
            :class="{ 'active-mid-title-btn': showTitleMenu }">
            <div>{{ currentView == 'list' || currentView == 'grid' ? $t("mindmap.mindmapHome.myMindMap") :
                currentView == 'recent' ? $t("mindmap.recentClick") : $t("mindmap.publicDisplay") }} <span><svg-icon icon-class="arrow-pre" class="arrow"
                        :class="{ 'active-arrow': showTitleMenu }" /> </span></div>
        </div>

        <!--SideBar-->
        <div class="sidebar-container" v-show="isLogin && currentView !== 'gallery'">
            <div class="sidebar">
                <!--大螢幕新增大按鈕-->
                <div class="add-btn" v-if="currentView == 'list' || currentView == 'grid' || currentView == 'recent' || currentView == 'public'"
                    @click="openSideAddBox()">{{ $t("mindmap.mindmapHome.add") }} </div>


                <!--大螢幕新增大按鈕End-->
                <div class="sidebar-content">
                    <div class="sidebar-item" @click="setMyMindMapView()"
                        :class="{ 'active': currentView == 'list' || currentView == 'grid' }">{{
        $t("mindmap.mindmapHome.myMindMap") }}</div>
                    <div v-if="canUsePublicDisplay" class="sidebar-item" @click="setView('public')" :class="{ 'active': currentView == 'public' }">
                        {{ $t("mindmap.publicDisplay") }}</div>
                    <div class="sidebar-item" @click="setView('recent')" :class="{ 'active': currentView == 'recent' }">
                        {{ $t("mindmap.recentClick") }}</div>
                    <div class="sidebar-item sidebar-item-gallery" @click="setView('gallery')">
                        {{ $t('mindmap.mindmapHome.galleryExploreTitle') }}</div>
                </div>
            </div>
            <div class="content">
                <!--listView-->
                <div class="mindmap-list" v-show="isLogin && currentView == 'list'">

                    <div class="list-wrap">
                        <table v-if="mindmapList.length > 0">
                            <thead>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th @click="getMyMindMapListBySort('mindmapName')">
                                        {{ $t("mindmap.mindmapHome.mindmapName") }}<span
                                            v-show="currentSortField == 'mindmapName'">{{ currentSortOrder == 'asc' ?
        '↓' :
        '↑' }}</span></th>
                                    <th @click="getMyMindMapListBySort('openCowork')">
                                        {{ $t("mindmap.mindmapHome.share") }}<span
                                            v-show="currentSortField == 'openCowork'">{{ currentSortOrder == 'asc' ? '↓'
        :
        '↑' }}</span></th>
                                    <th @click="getMyMindMapListBySort('updateTime')">
                                        {{ $t("mindmap.mindmapHome.updateTime") }}<span
                                            v-show="currentSortField == 'updateTime'">{{ currentSortOrder == 'asc' ? '↓'
        :
        '↑' }}</span></th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="mindmap in mindmapList" :key="mindmap.id">
                                    <td>
                                        <div class="more-btn" @click="openActionMenu(mindmap, $event)"><svg-icon
                                                iconClass="more"></svg-icon></div>
                                    </td>
                                    <td @click="clickMindItem(mindmap)" class="topic">
                                        <span v-show="mindmap.pk == 'MindMap'">{{ mindmap.mindmapName }} </span>

                                        <span v-show="mindmap.pk == 'MindCollect'">
                                            <svg-icon v-show="mindmap.collectType == 'task'" class="task-icon"
                                                iconClass="task"></svg-icon>
                                            <svg-icon v-show="mindmap.collectType == 'normal'" class="folder-icon"
                                                iconClass="folder"></svg-icon>

                                            <!-- <svg-icon v-show="!mindmap.openSubmit"
                                                class="forbidden-icon" iconClass="forbidden" /> &nbsp;&nbsp;-->
                                            {{ mindmap.mindCollectName }} </span>

                                    </td>
                                    <td>
                                        <!-- 心智圖收集模式 -->
                                        <span v-show="mindmap.pk == 'MindCollect'" class="coworkmode-text"
                                            @click="openMindCollectSetting(mindmap)">
                                            <!-- 不允許查看他人 -->
                                            <template v-if="!mindmap.allowViewOthers && mindmap.collectType == 'task'">
                                                <svg-icon class="close-eye-icon" iconClass="close-eye"></svg-icon>
                                                <span class="coworkmode-note-text">{{
        $t("mindmap.mindmapHome.coworkModeNoteText.task") }}</span>
                                            </template>
                                            <!-- 允許查看他人 -->
                                            <template v-if="mindmap.allowViewOthers && mindmap.collectType == 'task'">
                                                <svg-icon iconClass="eye"></svg-icon>
                                                <span class="coworkmode-note-text">{{
        $t("mindmap.mindmapHome.coworkModeNoteText.task") }}</span>
                                            </template>

                                            <!-- 任務模式 -->
                                            <template v-if="mindmap.collectType == 'normal'">
                                                <svg-icon iconClass="eye"></svg-icon>
                                                <span class="coworkmode-note-text">{{
        $t("mindmap.mindmapHome.coworkModeNoteText.view") }}</span>
                                            </template>
                                        </span>
                                        <!-- 協作模式 -->
                                        <span v-show="mindmap.openCowork" class="coworkmode-text"
                                            @click="openShareLinkBox(mindmap)">
                                            <!-- 查看模式 -->
                                            <template v-if="mindmap.coworkMode == 'view'">
                                                <svg-icon iconClass="eye"></svg-icon>
                                                <span class="coworkmode-note-text">{{
        $t("mindmap.mindmapHome.coworkModeNoteText.view") }}</span>
                                            </template>
                                            <!-- 編輯模式 -->
                                            <template v-else-if="mindmap.coworkMode == 'edit'">
                                                <svg-icon iconClass="pencil-alt"></svg-icon>
                                                <span class="coworkmode-note-text">{{
        $t("mindmap.mindmapHome.coworkModeNoteText.edit") }}</span>
                                            </template>
                                        </span>
                                        <!-- <span v-show="!mindmap.openCowork&&mindmap.pk!=='MindCollect'" class="coworkmode-text"></span> -->
                                    </td>
                                    <!-- <td>{{ mindmap.fluidContainerId }}</td> -->
                                    <!-- <td>{{ getTime(mindmap.createTime) }}</td> -->
                                    <td>{{ getTime(mindmap.updateTime) }}</td>
                                    <td>
                                        <div class="more-btn" @click="openActionMenu(mindmap, $event)"><svg-icon
                                                iconClass="more"></svg-icon></div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="text-md  mt-5 font-bold ml-5" v-else>
                            {{ $t("mindmap.mindmapHome.noData") }}
                        </div>
                    </div>
                    <div class="page-btn-wrap" v-if="mindmapList.length > 0">
                        <div v-for="pageBtn in pageBtns" :key="pageBtn" class="page-btn"
                            :class="{ 'page-btn-active': pageBtn == currentPageNum }"
                            @click="getMyMindMapListByPage(pageBtn)">
                            {{ pageBtn }}</div>
                    </div>

                </div>
                <!--gridView，部分樣式沿用教師上傳教材網Taiwind-->
                <div class="mindmap-grid" v-show="isLogin && currentView == 'grid'">

                    <div class="mindmapcard-wrap" v-if="mindmapList.length > 0">
                        <div class="card-item" v-for="mindmap in mindmapList" :key="mindmap.id">
                            <div class="img-top" @click="clickMindItem(mindmap)" v-show="mindmap.pk == 'MindMap'"
                                v-lazy-background="getMindMapImgUrl(mindmap)" />

                            <div class="collect-top" @click="clickMindItem(mindmap)"
                                v-show="mindmap.pk == 'MindCollect'">
                                <svg-icon v-show="mindmap.collectType == 'task'" class="task-icon"
                                    iconClass="task"></svg-icon>
                                <svg-icon v-show="mindmap.collectType == 'normal'" class="folder-icon"
                                    iconClass="folder"></svg-icon>
                                <!-- <svg-icon v-show="!mindmap.openSubmit" class="forbidden-icon" iconClass="forbidden" /> -->
                            </div>

                            <div class="card-textwrap">
                                <h5 @click="clickMindItem(mindmap)">{{ mindmap.pk == 'MindMap' ? mindmap.mindmapName :
        mindmap.mindCollectName }}</h5>
                                <p class="update-time">{{ getTime(mindmap.updateTime) }}</p>
                            </div>
                            <div class="more-btn" @click="openActionMenu(mindmap, $event)">
                                <svg-icon icon-class="more" />
                            </div>
                            <p class="share" v-show="mindmap.openCowork">
                                <svg-icon v-show="mindmap.coworkMode == 'view'" iconClass="eye"></svg-icon><span
                                    class="coworkmode-note-text" v-show="mindmap.coworkMode == 'view'">{{
        $t("mindmap.mindmapHome.coworkModeNoteText.view") }}</span>
                                <svg-icon v-show="mindmap.coworkMode == 'edit'" iconClass="pencil-alt"></svg-icon><span
                                    class="coworkmode-note-text" v-show="mindmap.coworkMode == 'edit'">{{
        $t("mindmap.mindmapHome.coworkModeNoteText.edit") }}</span>
                            </p>
                            <p class="share" v-show="mindmap.pk == 'MindCollect' && mindmap.collectType == 'task'">
                                <svg-icon v-show="!mindmap.allowViewOthers" class="close-eye-icon"
                                    iconClass="close-eye"></svg-icon><span class="coworkmode-note-text"
                                    v-show="!mindmap.allowViewOthers">{{
        $t("mindmap.mindmapHome.coworkModeNoteText.task") }}</span>
                                <svg-icon v-show="mindmap.allowViewOthers" iconClass="eye"></svg-icon><span
                                    class="coworkmode-note-text" v-show="mindmap.allowViewOthers">{{
        $t("mindmap.mindmapHome.coworkModeNoteText.task") }}</span>
                            </p>
                            <p class="share" v-show="mindmap.pk == 'MindCollect' && mindmap.collectType == 'normal'">
                                <svg-icon iconClass="eye"></svg-icon><span class="coworkmode-note-text">{{
        $t("mindmap.mindmapHome.coworkModeNoteText.view") }}</span>
                            </p>
                        </div>
                    </div>
                    <div class="text-md ml-8 mt-8 font-bold" v-else>
                        {{ $t("mindmap.mindmapHome.noData") }}
                    </div>
                    <div class="page-btn-wrap" v-if="mindmapList.length > 0">
                        <div v-for="pageBtn in pageBtns" :key="pageBtn" class="page-btn"
                            :class="{ 'page-btn-active': pageBtn == currentPageNum }"
                            @click="getMyMindMapListByPage(pageBtn)">
                            {{ pageBtn }}</div>
                    </div>
                </div>

                <!--最近使用-->
                <div class="mindmap-grid" v-show="isLogin && currentView == 'recent'">
                    <!-- 正常顯示歷史記錄 -->
                    <div class="mindmapcard-wrap" v-if="enterMindHistory.length > 0">
                        <div class="card-item" v-for="history in paginatedHistory" :key="history.id">
                            <div class="img-top" @click="clickHistoryItem(history)"
                                v-lazy-background="getHistoryImg(history.snapshotUrl)" />
                            <div class="card-textwrap">
                                <h5 @click="clickHistoryItem(history)">{{ history.mindmapName }}</h5>
                                <p class="update-time">{{ new Date(history.timestamp).toLocaleDateString() }}</p>
                                <br>

                            </div>
                            <div class="share"
                                v-if="history.mindmapCreator&&profile.teammodelId !== history.mindmapCreator.id">
                                <strong>{{ $t("mindmap.owner") }}{{ history.mindmapCreator.name }}</strong>
                            </div>
                            <!-- 星號按鈕 -->
                            <div class="history-star-btn" @click="toggleHistoryFavorite(history)">
                                <svg-icon v-if="history.isFavorite" icon-class="star-fill" class="star-icon star-active" />
                                <svg-icon v-else icon-class="star" class="star-icon" />
                            </div>

                        </div>
                    </div>
                    <!-- 空狀態和錯誤提示 -->
                    <div class="text-md ml-8 mt-8 font-bold" v-else>
                            {{ $t("mindmap.mindmapHome.noData")}}
                    </div>
                    <!-- 最近點閱分頁組件 -->
                    <div class="page-btn-wrap" v-if="enterMindHistory.length > 0">
                        <div v-for="pageBtn in historyPageBtns" :key="pageBtn" class="page-btn"
                            :class="{ 'page-btn-active': pageBtn == currentHistoryPageNum }"
                            @click="getHistoryByPage(pageBtn)">
                            {{ pageBtn }}</div>
                    </div>
                </div>

                <!--公開展示-->
                <div class="mindmap-grid" v-show="isLogin && currentView == 'public'">
                    <div class="mindmapcard-wrap" v-if="publicMindmapList.length > 0">
                        <div class="card-item" v-for="item in publicMindmapList" :key="item.id">
                            <div class="img-top" @click="openPublicMindMap(item)" v-lazy-background="getHistoryImg(item.snapshotUrl)" />
                            <div class="card-textwrap" @click="openPublicMindMap(item)" style="cursor:pointer;">
                                <h5>{{ item.title }}</h5>
                                <p class="update-time">{{ item.publishTime ? new Date(item.publishTime * 1000).toLocaleDateString() : '' }}</p>
                            </div>
                            <div class="public-view-count">
                                <svg-icon icon-class="eye" class="view-count-icon" />
                                <span>{{ formatViewCount(item.viewCount || 0) }}</span>
                            </div>
                            <div class="more-btn" @click="openPublicActionMenu(item, $event)">
                                <svg-icon icon-class="more" />
                            </div>
                        </div>
                    </div>
                    <div class="text-md ml-8 mt-8 font-bold" v-else>
                        {{ $t("mindmap.mindmapHome.noData") }}
                    </div>
                    <div class="page-btn-wrap" v-if="publicPageBtns.length > 1">
                        <div v-for="pageBtn in publicPageBtns" :key="pageBtn" class="page-btn"
                            :class="{ 'page-btn-active': pageBtn == currentPublicPageNum }"
                            @click="getMyPublicMindMapListByPage(pageBtn)">
                            {{ pageBtn }}</div>
                    </div>
                </div>
            </div>
        </div>


    </div>

    <!-- QR Code Dialog -->
    <QRCodeDialog v-if="showQRCodeCard" :url="qrCodeUrl" :short-code="qrCodeShortCode" :short-u-r-l-host="shortURLHost" @close="closeQRCode" />
</template>

<script setup>
/*eslint-disable*/
import { SharedMap } from "fluid-framework";
import api from "@/api";
import { onMounted, ref, reactive, inject, computed, nextTick, onBeforeUnmount, toRaw, getCurrentInstance, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import QRCodeDialog from '@/components/QRCodeDialog.vue';
import jwt_decode from "jwt-decode";
import CryptoJS from "crypto-js";
import { useMainStore } from "../stores/mainStore";
import { useRouter, useRoute } from 'vue-router';
import SvgIcon from "../components/SvgIcon.vue";
import SelectMenu from "../components/SelectMenu.vue";
import { AzureClient } from "@fluidframework/azure-client";
import { useMindMapStore } from "@/stores/mindMapStore";
import { is, useQuasar } from 'quasar'
import { mind, show } from "../api/jsmindlib/jsmind";
import main from "@/api/main";
import confProfile from "@/api/profile";
import i18n from "../locale";

const { BlobServiceClient } = require("@azure/storage-blob");
var serverLocation = main.getServerLocation();
let that = getCurrentInstance().proxy;
const { tm, locale, getLocaleMessage } = useI18n();

const containerSchema = reactive({
    initialObjects: {
        mindHistory: SharedMap,
        mindData: SharedMap,
        isDeleting: SharedMap,
        coworkMode: SharedMap,
    },
});
const shortUrlInput = ref('');
const $Message = inject("$Message");
const store = useMainStore();
const router = useRouter();
const route = useRoute();
const profile = reactive({
    name: "",
    teammodelId: "",
    picture: "",
});
const $q = useQuasar()
const shortURLHost = ref(confProfile.shortUrlHost[serverLocation]);
const mockImg = computed(() => `url("https://${location.host}/dall-e-img.webp")`)
const isLogin = ref(false);
const showShareLinkBox = ref(false);
const showComfirmDelete = ref(false);
const showComfirmDeleteCollect = ref(false);
const showComfirmDeleteCollectNormal = ref(false);
const showActionMenu = ref(false);

const showCollectActionMenu = ref(false);
const showCollectNormalActionMenu = ref(false);
const showPublicActionMenu = ref(false);
const currentPublicItem = ref(null);
const showConfirmDeletePublic = ref(false);

const showNavMenu = ref(false);
const showDetailInfo = ref(false);
const showRenameBox = ref(false);
const showMindCollectSetting = ref(false);
const showUpdateMindCollectSetting = ref(false);
const showUpdateMindCollectNormalSetting = ref(false);
const currentOpenFRUsage = ref(0); //開放分享的fluidrelay 之計算，只要沒有開放分享就不計在用量
const maxOpenFRUsage = ref(100); //開放分享的fluidrelay 之上限  
const isReachMaxOpenFRUsage = ref(false);

const isMindCollectSubmitOpen = ref(true);
const isMindCollectAllowView = ref(true);

const currentView = ref("list");
const mindmapList = ref([]);
const pageBtns = ref([]);
const currentPageNum = ref(1);
const currentSortField = ref("updateTime");
const currentSortOrder = ref("desc");
const currentMindMap = ref({});
const currentMindCollectName = ref({});
const currentMindCollectNormalName = ref({});


const coworkModeCate = ref([
    i18n.global.t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer"),
    i18n.global.t("mindmap.mindmapHome.coworkModeNoteText.editLongVer")
]);
const currentMindMapURL = ref("");
const actionMenuPos = reactive({
    x: 0,
    y: 0
})

const search = ref("");
const renameVal = ref("");
const renameMindCollectVal = ref("");
const renameMindCollectNormalVal = ref("");
const tokenRefreshInterval = ref(null);

// Setup ref for the component
const coworkModeSelect = ref(null);
let fluidIsDeleting = reactive({});
let fluidCoworkMode = reactive({}); //fluid 也記錄目前協作模式，擁有者在使用者操作時改變協作模式，須通知其他使用者
let fluidContainer = reactive({});

const enterMindHistory = ref([]);
const historyLoadingState = ref({ loading: false, error: false });

// 最近點閱分頁相關變數
const historyPageBtns = ref([]);
const currentHistoryPageNum = ref(1);
const historyPageSize = ref(12);
const paginatedHistory = ref([]);

// 公開展示分頁相關變數
const canUsePublicDisplay = ref(false);
const publicMindmapList = ref([]);
const publicPageBtns = ref([]);
const currentPublicPageNum = ref(1);
const publicPageSize = ref(12);

// 最近點閱篩選相關變數
const showOnlyFavorites = ref(false);
const filteredHistory = ref([]);

// Gallery 公開展示相關變數
const gallerySearch = ref('');
const galleryItems = ref([]);
const cardColorSeq = ref([]);

const PUBLISHER_NAME_MAP = { '1595321354': 'HiTeach' };
const getPublisherName = (publisher) => {
    if (!publisher) return '';
    return PUBLISHER_NAME_MAP[publisher.id] || publisher.name || '';
};

const CARD_COLORS = ['#d4f0e3', '#e4dffa', '#fdddd5', '#fdf3c0', '#d6eeff'];
const genCardColors = (count, prevSeq = []) => {
    const seq = [...prevSeq];
    for (let i = seq.length; i < count; i++) {
        const prev = seq[i - 1];
        const pool = CARD_COLORS.filter(c => c !== prev);
        seq.push(pool[Math.floor(Math.random() * pool.length)]);
    }
    return seq;
};
const galleryPage = ref(1);
const galleryHasMore = ref(false);
const isGalleryLoading = ref(false);
const galleryTotal = ref(0);

// Hero 標題變色（設計稿：索引4=理→珊瑚，索引6=麼→藍紫，索引8=法→珊瑚）
const heroTitleHtml = computed(() => {
    const title = i18n.global.t('mindmap.mindmapHome.heroTitle');
    const CORAL = '#D95F52';
    const VIOLET = '#7B68C8';
    return title.split('').map((ch, i) => {
        const color = [4, 8].includes(i) ? CORAL : i === 6 ? VIOLET : null;
        const safe = ch.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
        return color ? `<span style="color:${color}">${safe}</span>` : safe;
    }).join('');
});

// 經典範例參考卡片
const templateCardsBases = [
    { id: 2, color: '#e06b5a', icon: 'note',           satellites: [[18,50],[82,50],[35,24],[65,24],[35,76],[65,76]] },
    { id: 3, color: '#e8a020', icon: 'hi-mind',        satellites: [[15,35],[50,15],[85,35],[85,65],[50,85],[15,65],[25,50],[75,50]] },
    { id: 4, color: '#6788d0', icon: 'clipboard-list', satellites: [[20,35],[20,65],[80,35],[80,65],[50,20],[50,80]] },
    { id: 5, color: '#2d9a76', icon: 'microphone',     satellites: [[18,50],[82,50],[38,22],[62,22],[38,78],[62,78]] },
    { id: 6, color: '#9b6dce', icon: 'pen',            satellites: [[20,50],[80,50],[50,20],[50,80],[28,30],[72,30]] },
];
const templateCards = computed(() => {
    const msgs = getLocaleMessage(locale.value);
    const labels = msgs?.mindmap?.mindmapHome?.galleryTemplateCards || [];
    return templateCardsBases.map((base, i) => ({
        ...base,
        title: labels[i]?.title || '',
        sub:   labels[i]?.sub   || '',
    }));
});

// Gallery Hero 互動浮動節點
const heroMouse = ref({ x: 0.5, y: 0.5 });
const heroNodes = [
    { x: 15, y: 25, colorClass: 'coral', icon: 'hi-mind' },
    { x: 80, y: 20, colorClass: 'violet', icon: 'note' },
    { x: 85, y: 60, colorClass: 'sun',    icon: 'palette' },
    { x: 68, y: 82, colorClass: 'mint',   icon: 'star-fill' },
    { x: 18, y: 72, colorClass: 'coral',  icon: 'pen' },
    { x: 5,  y: 46, colorClass: 'violet', icon: 'microphone' },
];
const onHeroMouseMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    heroMouse.value = { x: (e.clientX - r.left) / r.width, y: (e.clientY - r.top) / r.height };
};
const getNodeStyle = (node, i) => {
    const cx = 50, cy = 50;
    const dx = (heroMouse.value.x * 100 - cx) * 0.08;
    const dy = (heroMouse.value.y * 100 - cy) * 0.08;
    const offX = (node.x - cx) > 0 ? -dx : dx;
    const offY = (node.y - cy) > 0 ? -dy : dy;
    return {
        left: `calc(${node.x}% + ${offX}px)`,
        top: `calc(${node.y}% + ${offY}px)`,
        animationDelay: `${i * 0.7}s`,
    };
};

const showAddBox = ref(false);
const showSideAddBox = ref(false);
const showSearchBox = ref(false);
const showTitleMenu = ref(false);
const showCollectNormalModal = ref(false);
const currentPageSize = ref(12);

const showSaveCoworkBtn = computed(() => {
    const coworkModeTextOrigin = coworkModeSelect.value.currentSelect === that.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") ? "view" : "edit";
    return currentMindMap.value.coworkMode && currentMindMap.value.coworkMode != coworkModeTextOrigin;
});

/**
 * 處理來自 HiTeachCC 父視窗的認證訊息
 */
const handleParentMessage = async (event) => {
    // Origin 白名單驗證
    const allowedOrigins = [
        // Global 站點
        'https://hiteachcc.teammodel.net',
        'https://hiteachcc-rc.teammodel.net',
        'https://hiteachcc-test.teammodel.net',
        // CN 站點
        'https://hiteachcc.teammodel.cn',
        'https://hiteachcc-rc.teammodel.cn',
        'https://hiteachcc-test.teammodel.cn',
        // 本地開發 (HiTeachCC 的本地端口)
        'http://localhost:8080'
    ];

    if (!allowedOrigins.includes(event.origin)) {
        console.warn('[MindMap] 拒絕來自未授權來源的訊息:', event.origin);
        return;
    }

    // 處理 HiTeachCC.Auth 和 HiTeachCC.TokenRefresh(共用邏輯)
    if (event.data.action === 'HiTeachCC.Auth' || event.data.action === 'HiTeachCC.TokenRefresh') {
        const isInitialAuth = event.data.action === 'HiTeachCC.Auth';
        console.log(`[MindMap] 收到${isInitialAuth ? '初始認證' : 'Token 刷新'}資料`);
        console.log(event.data);
        const { accessToken, idToken, expiresIn } = event.data;

        // 儲存 Token 到 localStorage
        localStorage.setItem('access_token', accessToken);
        localStorage.setItem('id_token', idToken);
        localStorage.setItem('expires_in', expiresIn.toString());

        // 解碼 JWT 取得用戶資訊
        const decoded = jwt_decode(idToken);

        // 儲存 Profile
        const profileData = {
            id: decoded.sub,
            teammodelId: decoded.sub,
            name: decoded.name,
            picture: decoded.picture
        };
        localStorage.setItem('profile', JSON.stringify(profileData));

        // 更新 Vue 狀態
        isLogin.value = true;
        store.setIsLogIn(true);
        profile.name = decoded.name;
        profile.teammodelId = decoded.sub;
        profile.picture = decoded.picture;

        // 只在初始認證時載入資料(Token 刷新不重複載入)
        if (isInitialAuth) {
            // 從 localStorage 讀取用戶視圖偏好
            const savedView = localStorage.getItem(`mindmap_view_preference_${profile.teammodelId}`);
            if (savedView) {
                currentView.value = savedView;
            }

            // 載入用戶的心智圖資料
            $q.loading.show();

            // 只有在最近點閱視圖才載入歷史記錄
            if (currentView.value === 'recent') {
                loadHistoryFromLocalStorage();
                loadMindClickHistory();
            }

            let data = {
                tmid: profile.teammodelId,
                pageSize: currentPageSize.value,
                pageNumber: 1,
                sortField: currentSortField.value,
                sortOrder: currentSortOrder.value
            };

            await getMyMindMapList(data);
            $q.loading.hide();

            // 檢查是否有公開展示白名單權限
            try {
                const accessRes = await api.mindmapAPI.checkPublicFeatureAccess({ tmid: profile.teammodelId });
                canUsePublicDisplay.value = accessRes?.allowed ?? false;
            } catch {
                canUsePublicDisplay.value = false;
            }

            console.log('[MindMap] HiTeachCC 登入成功，已載入用戶資料');
        } else {
            console.log('[MindMap] Token 已更新');
        }
    }
};

const openSearchBox = () => {
    showSearchBox.value = true;
}

const openAddBox = () => {
    showAddBox.value = !showAddBox.value;
}
const openSideAddBox = () => {
    showSideAddBox.value = !showSideAddBox.value;
}

const openTitleMenu = () => {
    showTitleMenu.value = !showTitleMenu.value;
}

const closeSearchBox = () => {
    showSearchBox.value = false;
    resetSearch();
}

const openComfirmDeleteCollect = () => {
    showComfirmDeleteCollect.value = true;
}

const openComfirmDeleteCollectNormal = () => {
    showComfirmDeleteCollectNormal.value = true;
}

const closeComfirmDeleteCollectNormal = () => {
    showComfirmDeleteCollectNormal.value = false;
}

const closeComfirmDeleteCollect = () => {
    showComfirmDeleteCollect.value = false;
}
// QR Code
const showQRCodeCard = ref(false);
const qrCodeUrl = ref('');
const qrCodeShortCode = ref('');
const openQRCode = (url, shortCode) => {
    qrCodeUrl.value = url;
    qrCodeShortCode.value = shortCode;
    showQRCodeCard.value = true;
};
const closeQRCode = () => { showQRCodeCard.value = false; };

const copyShortUrl = () => {
    const url = shortURLHost.value + currentMindMapURL.value;
    const input = document.createElement('input');
    input.value = url;
    document.body.appendChild(input);
    input.select();
    document.execCommand('Copy');
    document.body.removeChild(input);
    $Message.info(that.$t("mindmap.mainMenu.alreadyCopied"));
}

// 重新獲取 ClipCode 的功能
const refreshClipCode = async (mindmap) => {
    try {
        // 先檢查現有的簡碼狀態
        if (mindmap.urlClipCode) {
            const checkData = {
                clipCode: mindmap.urlClipCode
            };
            
            try {
                await api.mindmapAPI.getOrigDataFromClipCode(checkData);
                // 如果沒有 404 錯誤，表示簡碼還有效
                $Message.info(that.$t("mindmap.mindmapHome.clipCodeStillValid"));
                return;
            } catch (error) {
                // 只有 404 錯誤才繼續重新生成簡碼
                if (error.response?.status !== 404) {
                    console.error("檢查簡碼時發生錯誤:", error);
                    $Message.error(that.$t("mindmap.mindmapHome.checkClipCodeError"));
                    return;
                }
                // 404 錯誤表示簡碼已過期，繼續下方的重新生成流程
            }
        }
        
        // 生成新的簡碼
        let origData, dataForClip;
        
        if (mindmap.collectType === 'normal') {
            // MindCollectNormal 的簡碼生成
            origData = `${window.location.origin}/mindcollectnormal?cid=${mindmap.id}`;
            dataForClip = {
                "origDataList": [{ "origData": origData }],
                "type": "mindmap",
                "useShortDigits": false,
                "isPermanent": false,
                "lang": that.$i18n.locale.toLowerCase(),
                "note": JSON.stringify({mindCollectNormalName: mindmap.mindCollectName})
            };
        } else if (mindmap.collectType) {
            // MindCollect 的簡碼生成
            origData = `${window.location.origin}/mindcollect?cid=${mindmap.id}`;
            dataForClip = {
                "origDataList": [{ "origData": origData }],
                "type": "mindmap",
                "useShortDigits": false,
                "isPermanent": false,
                "lang": that.$i18n.locale.toLowerCase(),
                "note": JSON.stringify({mindCollectName: mindmap.mindCollectName})
            };
        } else {
            // MindMap 的簡碼生成
            origData = `${window.location.origin}/MindMapClone?id=${mindmap.id}`;
            dataForClip = {
                "origDataList": [{ "origData": origData }],
                "type": "mindmap",
                "useShortDigits": false,
                "isPermanent": false,
                "lang": that.$i18n.locale.toLowerCase(),
                "note": JSON.stringify({mindmapName: mindmap.mindmapName})
            };
        }
        
        const clipRes = await api.mindmapAPI.getClipCode(dataForClip);
        const newClipCode = clipRes.clipCodePairs[0].clipCode;
        
        // 更新資料庫
        if (mindmap.collectType === 'normal' || mindmap.collectType) {
            // 更新收集區的簡碼
            const updateData = {
                cid: mindmap.id,
                editor: {
                    id: mindmap.editor ? mindmap.editor.id : profile.teammodelId,
                    name: mindmap.editor ? mindmap.editor.name : profile.name
                },
                urlClipCode: newClipCode,
            };
            await api.mindmapAPI.updateMindCollect(updateData);
        } else {
            // 更新心智圖的簡碼  
            const updateData = {
                id: mindmap.id,
                mindmapEditor: {
                    id: mindmap.mindmapEditor ? mindmap.mindmapEditor.id : profile.teammodelId,
                    name: mindmap.mindmapEditor ? mindmap.mindmapEditor.name : profile.name
                },
                urlClipCode: newClipCode,
            };
            await api.mindmapAPI.updateMindMap(updateData);
        }
        
        // 更新本地資料
        mindmap.urlClipCode = newClipCode;
        currentMindMapURL.value = newClipCode;
        
        $Message.success(that.$t("mindmap.mindmapHome.clipCodeRefreshSuccess"));
        
    } catch (error) {
        console.error("重新獲取簡碼失敗:", error);
        $Message.error(that.$t("mindmap.mindmapHome.clipCodeRefreshError"));
    }
}

// 檢查簡碼有效性並自動重新生成的函數
const checkAndRefreshClipCodeIfNeeded = async (mindmap) => {
    if (!mindmap || !mindmap.urlClipCode) {
        return;
    }

    const now = Date.now();
    const ninetyDaysInMs = 90 * 24 * 60 * 60 * 1000; // 90天的毫秒數
    
    // 檢查是否有 urlClipCodeUpdateTime，如果沒有或超過90天，則檢查簡碼有效性
    if (!mindmap.urlClipCodeUpdateTime || (now - mindmap.urlClipCodeUpdateTime) > ninetyDaysInMs) {
        try {
            const checkData = { clipCode: mindmap.urlClipCode };
            await api.mindmapAPI.getOrigDataFromClipCode(checkData);
            // 簡碼仍有效，不需重新生成
        } catch (error) {
            if (error.response?.status === 404) {
                // 簡碼已失效，重新生成
                await autoRefreshClipCode(mindmap);
            } else {
                console.error("檢查簡碼時發生錯誤:", error);
            }
        }
    }
};

// 自動重新生成簡碼的函數
const autoRefreshClipCode = async (mindmap) => {
    try {
        // 獲取新的簡碼
        const currentMindMapURL = `${location.origin}/mindcollect?cid=${mindmap.id}`;
        const dataForClip = {
            "origDataList": [{ "origData": currentMindMapURL }],
            "type": "mindmap",
            "useShortDigits": false,
            "isPermanent": false,
            "lang": that.$i18n.locale.toLowerCase(),
            "note": JSON.stringify({mindCollectName: mindmap.mindCollectName || mindmap.mindmapName})
        };
        const clipRes = await api.mindmapAPI.getClipCode(dataForClip);
        const newClipCode = clipRes.clipCodePairs[0].clipCode;

        // 更新心智圖收集的簡碼
        if (mindmap.pk === "MindCollect") {
            const updateData = {
                cid: mindmap.id,
                editor: {
                    id: mindmap.editor ? mindmap.editor.id : profile.teammodelId,
                    name: mindmap.editor ? mindmap.editor.name : profile.name
                },
                urlClipCode: newClipCode,
            };
            await api.mindmapAPI.updateMindCollect(updateData);
        }
        
        // 更新本地資料
        mindmap.urlClipCode = newClipCode;
        mindmap.urlClipCodeUpdateTime = Date.now();
        
        console.log("簡碼已自動更新:", newClipCode);
        
    } catch (error) {
        console.error("自動重新獲取簡碼失敗:", error);
    }
};

// 檢查是否需要顯示簡碼更新提示
const checkAndShowClipCodeUpdateNotice = (mindmap) => {
    if (!mindmap || !mindmap.urlClipCodeUpdateTime || !mindmap.createTime) {
        return;
    }

    const now = Date.now();
    const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000; // 7天的毫秒數
    const createTimeMs = mindmap.createTime * 1000; // createTime 是秒，轉換為毫秒
    const updateTime = mindmap.urlClipCodeUpdateTime;
    
    // 檢查是否是最近更新的（7天內），且不是創建時的初始簡碼
    // 使用時間差來判斷，容忍5分鐘的誤差
    const timeDiff = Math.abs(updateTime - createTimeMs);
    const fiveMinutesInMs = 5 * 60 * 1000; // 5分鐘的毫秒數
    
    if ((now - updateTime) <= sevenDaysInMs && timeDiff > fiveMinutesInMs) {
        $Message.warning(that.$t("mindmap.mindmapHome.clipCodeAutoUpdated"));
    }
};

const trackView = (mindmap, type = 'MindMap') => {
    if (!isLogin.value || !profile.teammodelId) return;
    api.mindmapAPI.trackView({
        entry: {
            id: mindmap.id,
            type,
            mindmapName: mindmap.mindmapName || mindmap.title || '',
            snapshotUrl: mindmap.snapshotUrl || '',
            mindmapCreator: mindmap.mindmapCreator || mindmap.publisher || { id: profile.teammodelId, name: profile.name },
            timestamp: Date.now()
        }
    }).catch(() => {});
};

const saveEnterMindHistoryLocal = async (mindmap, type = 'MindMap') => {
    if (!mindmap || !profile.teammodelId) return;
    const storageKey = `enterMindHistory_${profile.teammodelId}`;
    let histories = JSON.parse(localStorage.getItem(storageKey) || '[]');
    
    // 查找現有記錄以保留 isFavorite 狀態
    const existingHistory = histories.find(h => h.id === mindmap.id);
    
    const history = {
        id: mindmap.id,
        type: type,
        mindmapName: mindmap.mindmapName || mindmap.title || '',
        snapshotUrl: mindmap.snapshotUrl || '',
        timestamp: Date.now(),
        mindmapCreator: mindmap.mindmapCreator ? {
            id: mindmap.mindmapCreator.id,
            name: mindmap.mindmapCreator.name
        } : {
            id: profile.teammodelId,
            name: profile.name
        },
        // 保留現有的 isFavorite 狀態，預設為 false
        isFavorite: existingHistory?.isFavorite || false
    };

    // 移除相同 id 的舊記錄
    histories = histories.filter(h => h.id !== history.id);

    // 新增到開頭
    histories.unshift(history);

    // 限制最多保存 100 筆，優先保留有星號的項目
    if (histories.length > 100) {
        // 分離有星號和沒星號的項目
        const favoriteItems = histories.filter(h => h.isFavorite);
        const nonFavoriteItems = histories.filter(h => !h.isFavorite);
        
        // 計算需要保留的項目數量
        if (favoriteItems.length >= 100) {
            // 如果星號項目就超過 100 筆，只保留最新的 100 筆星號項目
            histories = favoriteItems.slice(0, 100);
        } else {
            // 保留所有星號項目，再從非星號項目中保留最新的項目湊滿 100 筆
            const remainingSlots = 100 - favoriteItems.length;
            const selectedNonFavorites = nonFavoriteItems.slice(0, remainingSlots);
            histories = [...favoriteItems, ...selectedNonFavorites];
            // 重新按時間排序
            histories.sort((a, b) => b.timestamp - a.timestamp);
        }
    }

    localStorage.setItem(storageKey, JSON.stringify(histories));
    enterMindHistory.value = [...histories];
    
    // 更新分頁
    updateHistoryPagination();
}
const getMyMindMapListBySort = async (field) => {
    currentPageNum.value = 1;
    if (currentSortField.value == field) {  // 重複點擊
        currentSortOrder.value = currentSortOrder.value == 'asc' ? 'desc' : 'asc';
    } else {
        currentSortField.value = field;
        currentSortOrder.value = 'asc';
    }
    let data = {
        tmid: profile.teammodelId,
        pageSize: currentPageSize.value,
        pageNumber: currentPageNum.value,
        sortField: currentSortField.value,
        sortOrder: currentSortOrder.value
    }
    mindmapList.value = [];
    await getMyMindMapList(data);
}
const initializeAzureClient = async () => {
    try {
        localStorage.removeItem("cachedFluidRelayToken"); // 初始化先移除 localStorage
        const fluidConfig = await api.mindmapAPI.getFluidRelayConfig();
        let dataCenter = (serverLocation.includes("cn")) ? "china" : "global";
        const serviceConfig = {
            connection: {
                type: "remote",
                tenantId: fluidConfig[dataCenter]?.fluidRelayTenantId,
                tokenProvider: new api.MyAzTokenProvider(api.mindmapAPI.fluidTokenUrl, {
                    "idToken": "",
                    "id": profile.teammodelId,
                    "name": profile.name,
                }),
                endpoint: fluidConfig[dataCenter]?.fluidRelayEndpoint,
            },
        };
        return new AzureClient(serviceConfig);
    } catch (error) {
        console.error("初始化 AzureClient 失敗:", error);
        throw error;
    }
};

const setMyMindMapView = () => {
    // 優先使用已儲存的視圖偏好
    const savedView = localStorage.getItem(`mindmap_view_preference_${profile.teammodelId}`);
    if (savedView && (savedView === 'list' || savedView === 'grid')) {
        setView(savedView);
    }  else {
        setView('list');
    }
}


const getFluidMindData = async (Fid) => {
    let retryCount = 0;
    const maxRetries = 3;
    const retryDelay = 2000; // 2秒

    const tryGetContainer = async () => {
        try {
            const client = await initializeAzureClient();
            // 捕捉 getContainer 操作中的異常
            const result = await client.getContainer(Fid, containerSchema, "2");
            const container = result.container;
            // 等容器完全連線後再讀取，避免節點資料未 sync 就取到不完整資料
            if (container.connectionState !== 2 /* Connected */) {
                await new Promise((resolve, reject) => {
                    const timer = setTimeout(() => reject(new Error('container connected timeout')), 10000);
                    container.once('connected', () => { clearTimeout(timer); resolve(); });
                });
            }
            const fluidMindData = container.initialObjects.mindData; //存放markdown資料
            container.dispose();
            return fluidMindData;
        } catch (error) {
            console.error(`嘗試 ${retryCount + 1}/${maxRetries} 失敗:`, error);
            $Message.info(that.$t("mindmap.tryingToGetContainer"));
            if (retryCount < maxRetries - 1) {
                retryCount++;
                console.log(`等待 ${retryDelay / 1000} 秒後重試...`);
                return new Promise(resolve => setTimeout(() => resolve(tryGetContainer()), retryDelay));
            } else {
                console.error(`已重試 ${maxRetries} 次，仍然失敗`);
                $Message.error(that.$t("mindmap.cannotConnect"));
                return; // 如果無法獲取容器，直接退出
            }
        }
    };

    return tryGetContainer();
}
// 登入後執行 pending action（如：複製公開心智圖）
const handlePendingAction = async () => {
    const raw = localStorage.getItem('pendingAction');
    if (!raw) return;
    let action;
    try { action = JSON.parse(raw); } catch { return; }
    localStorage.removeItem('pendingAction');

    if (action.action === 'copyPublicMindMap' && action.publicId) {
        // 轉跳回 HTwbMind，由有 jm 實例的頁面執行複製
        window.location.href = `/HTwbMind?loadPublic=true&publicId=${action.publicId}&autoCopy=true`;
    }

    if (action.action === 'copyPlaygroundMindMap') {
        // 轉跳回遊樂場，快照已在 sessionStorage，頁面載入後自動複製
        window.location.href = `/playground?autoCopy=true`;
    }
};

const copyMindMap = async (mindmap) => {
    //先斷開
    if (fluidContainer && typeof fluidContainer.dispose === 'function') {
        fluidContainer.dispose();
    }

    const isFromHT = sessionStorage.getItem("jumpFrom") === "HT";

    if (isLogin.value) {
        if (isFromHT) { $Message.info(that.$t("mindmap.mindmapHome.setCoworkInHTinfo")); }
        let data = {
            "mindmapName": mindmap.mindmapName + `（${that.$t('mindmap.copyToMine.copyLabel')}）`,
            "mindmapCreator": {
                "id": profile.teammodelId,
                "name": profile.name
            },
            "mindmapData": "",
            "fluidContainerId": "",
            "openCowork": isFromHT ? true : false,
            "coworkMode": isFromHT ? "edit" : "view",
            "snapshotUrl": mindmap.snapshotUrl,
        }

        try {
            const client = await initializeAzureClient();

            const { container } = await client.createContainer(containerSchema, "2;");
            data.fluidContainerId = await container.attach();

            fluidIsDeleting = container.initialObjects.isDeleting;
            fluidCoworkMode = container.initialObjects.coworkMode;

            let fluidMindData = container.initialObjects.mindData;
            const copyMindData = await getFluidMindData(mindmap.fluidContainerId);

            console.log(copyMindData, "複製的mindData")
            if (copyMindData) {
                const fallbackEditor = mindmap.mindmapCreator
                    ? { seat: mindmap.mindmapCreator.id, name: mindmap.mindmapCreator.name }
                    : null;
                for (const [key, value] of copyMindData) {
                    try {
                        const parsed = JSON.parse(value);
                        if (parsed.data && !parsed.data.finalEditor && fallbackEditor)
                            parsed.data.finalEditor = fallbackEditor;
                        if (key === 'root') {
                            parsed.topic = `<p>${data.mindmapName}</p>`;
                            if (parsed.data) parsed.data.nodeText = data.mindmapName;
                        }
                        fluidMindData.set(key, JSON.stringify(parsed));
                    } catch {
                        fluidMindData.set(key, value);
                    }
                }
            }

            //初始化先把isDeleting設為false
            fluidIsDeleting.set('data', false);

            fluidCoworkMode.set('data', JSON.stringify({
                "coworkMode": isFromHT ? "edit" : "view",
                "openCowork": isFromHT ? true : false,
            }));


            const res = await api.mindmapAPI.createMindMap(data);

            router.push({
                path: '/MindMapClone',
                query: {
                    id: res.id,
                    openCowork: res.openCowork,
                }
            });


        } catch (error) {
            console.error(error);
            $Message.error(that.$t("mindmap.mindmapHome.initializeFailed"));
        }
    }
}
const openMindCollectSetting = async (mindmap) => {
    if (mindmap) { //如有傳入在校正一次
        currentMindMap.value = mindmap;
    }

    // 檢查並自動更新簡碼（如果超過90天且無效）
    await checkAndRefreshClipCodeIfNeeded(currentMindMap.value);

    // 檢查並顯示簡碼更新提示（如果在7天內更新過且不是創建時間）
    checkAndShowClipCodeUpdateNotice(currentMindMap.value);

    showUpdateMindCollectSetting.value = true;
    // currentMindMapURL.value = `${location.origin}/mindcollect?cid=${currentMindMap.value.id}`;
    currentMindMapURL.value = currentMindMap.value.urlClipCode
    currentMindCollectName.value = currentMindMap.value.mindCollectName;
    isMindCollectSubmitOpen.value = currentMindMap.value.openSubmit;
    isMindCollectAllowView.value = currentMindMap.value.allowViewOthers;
}
const openMindCollectNormalSetting = async (mindmap) => {
    if (mindmap) { //如有傳入在校正一次
        currentMindMap.value = mindmap;
    }

    // 檢查並自動更新簡碼（如果超過90天且無效）
    await checkAndRefreshClipCodeIfNeeded(currentMindMap.value);

    // 檢查並顯示簡碼更新提示（如果在7天內更新過且不是創建時間）
    checkAndShowClipCodeUpdateNotice(currentMindMap.value);

    renameMindCollectNormalVal.value = currentMindMap.value.mindCollectName;

    showUpdateMindCollectNormalSetting.value = true;
    // currentMindMapURL.value = `${location.origin}/mindcollect?cid=${currentMindMap.value.id}`;
    currentMindMapURL.value = currentMindMap.value.urlClipCode
    currentMindCollectNormalName.value = currentMindMap.value.mindCollectName;
    isMindCollectSubmitOpen.value = currentMindMap.value.openSubmit;
    isMindCollectAllowView.value = currentMindMap.value.allowViewOthers;
}
const openCollectNormalModal = () => {
    if (isReachMaxOpenFRUsage.value) {
        $Message.error({
            content: that.$t("mindmap.reachMaxOpenFRUsage"),
            duration: 10,
            closable: true

        });

        return;

    }
    currentMindCollectNormalName.value = that.$t("mindmap.mindmapHome.mindCollectNormal.defaultName");
    isMindCollectAllowView.value = true;
    isMindCollectSubmitOpen.value = true;
    showCollectNormalModal.value = true;
}

const createMindMap = async (option) => {
    if (isReachMaxOpenFRUsage.value) {
        $Message.error({
            content: that.$t("mindmap.reachMaxOpenFRUsage"),
            duration: 10,
            closable: true

        });
        return;
    }

    const stayInHome = option && option?.stayInHome === true;

    const coworkEditMode = option && option?.coworkEditMode === true;

    const isFromHT = sessionStorage.getItem("jumpFrom") === "HT";


    if (isLogin.value) {
        if (isFromHT) { $Message.info(that.$t("mindmap.mindmapHome.setCoworkInHTinfo")); }
        let data = {
            "mindmapName": that.$t("mindmap.defaultMind.root"),
            "mindmapCreator": {
                "id": profile.teammodelId,
                "name": profile.name
            },
            "mindmapData": "",
            "fluidContainerId": "",
            "openCowork": isFromHT || coworkEditMode ? true : false,
            "coworkMode": isFromHT || coworkEditMode ? "edit" : "view",
        }

        try {
            $Message.info(that.$t("mindmap.mindmapHome.initialize"));
            const client = await initializeAzureClient();


            const { container } = await client.createContainer(containerSchema, "2;");
            data.fluidContainerId = await container.attach();

            fluidIsDeleting = container.initialObjects.isDeleting;
            fluidCoworkMode = container.initialObjects.coworkMode;

            let fluidMindData = container.initialObjects.mindData;
            let initMindData = [
                {
                    "id": "root",
                    "topic": "<p>" + that.$t("mindmap.defaultMind.root") + "</p>",
                    "expanded": true,
                    "isroot": true,
                    "nodeText": that.$t("mindmap.defaultMind.root"),
                    "nodeImg": "",
                    "nodeLink": "",
                    "lock": false
                },
                {
                    "id": "uuid4",
                    "topic": "<p>" + that.$t("mindmap.defaultMind.node4") + "</p>",
                    "expanded": true,
                    "parent": { "id": "root" },
                    "direction": "left",
                    "data": {
                        "nodeText": that.$t("mindmap.defaultMind.node4"),
                        "nodeImg": "",
                        "nodeLink": "",
                        "lineColor": "red",
                        "background-color": "rgb(255, 191, 215)",
                        "lock": false
                    }
                },
                {
                    "id": "uuid3",
                    "topic": "<p>" + that.$t("mindmap.defaultMind.node3") + "</p>",
                    "expanded": true,
                    "parent": { "id": "root" },
                    "direction": "left",
                    "data": {
                        "nodeText": that.$t("mindmap.defaultMind.node3"),
                        "nodeImg": "",
                        "nodeLink": "",
                        "lineColor": "#0000ff",
                        "background-color": "rgb(139, 243, 255)",
                        "lock": false
                    }
                },
                {
                    "id": "uuid1",
                    "topic": "<p>" + that.$t("mindmap.defaultMind.node1") + "</p>",
                    "expanded": true,
                    "parent": { "id": "root" },
                    "direction": "right",
                    "data": {
                        "nodeText": that.$t("mindmap.defaultMind.node1"),
                        "nodeImg": "",
                        "nodeLink": "",
                        "lineColor": "orange",
                        "background-color": "rgb(255, 238, 139)",
                        "lock": false
                    }
                },
                {
                    "id": "uuid2",
                    "topic": "<p>" + that.$t("mindmap.defaultMind.node2") + "</p>",
                    "expanded": true,
                    "parent": { "id": "root" },
                    "direction": "right",
                    "data": {
                        "nodeText": that.$t("mindmap.defaultMind.node2"),
                        "nodeImg": "",
                        "nodeLink": "",
                        "lineColor": "green",
                        "background-color": "rgb(211, 255, 139)",
                        "lock": false
                    }
                }
            ]
            initMindData.forEach((item) => {
                fluidMindData.set(item.id, JSON.stringify(item));
            })

            //初始化先把isDeleting設為false
            fluidIsDeleting.set('data', false);

            fluidCoworkMode.set('data', JSON.stringify({
                "coworkMode": isFromHT ? "edit" : "view",
                "openCowork": isFromHT ? true : false,
            }));

            const res = await api.mindmapAPI.createMindMap(data);

            const origData = `${window.location.origin}/MindMapClone?id=${res.id}`;
            const dataForClip = {
                "origDataList": [{ "origData": origData }],
                "type": "mindmap",
                "useShortDigits": false,
                "isPermanent": false,
                "lang": that.$i18n.locale.toLowerCase(),
                "note": JSON.stringify({mindmapName:data.mindmapName})
            };

            const clipRes = await api.mindmapAPI.getClipCode(dataForClip);
            const clipCode = clipRes.clipCodePairs[0].clipCode;

            await api.mindmapAPI.updateMindMap({
                id: res.id,
                mindmapEditor: {
                    id: profile.teammodelId,
                    name: profile.name,
                },
                urlClipCode: clipCode,
            });

            if (stayInHome) {
                console.log(res);
                return res;
            } else {
                router.push({
                    path: '/MindMapClone',
                    query: {
                        id: res.id,
                        openCowork: res.openCowork,
                    }
                });
            }

        } catch (error) {
            console.error(error);
            $Message.error(that.$t("mindmap.mindmapHome.initializeFailed"));
        }
    }

    // router.push("/MindMap");
}



const createMindMapCollect = () => {
    if (isReachMaxOpenFRUsage.value) {
        $Message.error({
            content: that.$t("mindmap.reachMaxOpenFRUsage"),
            duration: 10,
            closable: true

        });

        return;

    }
    currentMindCollectName.value = that.$t("mindmap.mindmapHome.mindCollect.defaultName");
    showMindCollectSetting.value = true;
    isMindCollectAllowView.value = true;
    isMindCollectSubmitOpen.value = true;

    // router.push("/mindcollect");
}
const deleteMindCollectAllContent = async (mindmap) => {
    try {
        const res = await api.mindmapAPI.getMindCollectById({ cid: mindmap.id });
        const mindCollectList = res.mindmapList;
        const ids = mindCollectList.map((item) => item.id);

        if (ids.length !== 0) {
            const data = { ids: ids };
            await api.mindmapAPI.deleteMindMaps(data);
        }
        await api.mindmapAPI.deleteMindCollect({ cid: mindmap.id });

        $Message.info(that.$t("mindmap.mindmapHome.deletingOKinFront"));
        showComfirmDeleteCollect.value = false;
        showComfirmDeleteCollectNormal.value = false;

        //拉新資料
        await getMyMindMapListBySort(currentSortField.value);


    } catch (error) {
        console.error('Error deleting mind collect content:', error);
    }
}


const confirmToUpdateMindCollect = async () => {

    try {
        const data = {
            "cid": currentMindMap.value.id,
            "mindCollectName": renameMindCollectVal.value.length !== 0 ? renameMindCollectVal.value : currentMindCollectName.value,
            "editor": {
                "id": profile.teammodelId,
                "name": profile.name,
            },
            "openSubmit": isMindCollectSubmitOpen.value,
            "allowViewOthers": isMindCollectAllowView.value,
        }
        await api.mindmapAPI.updateMindCollect(data);

        $Message.info(that.$t("mindmap.mindmapHome.saveOk"));
        showUpdateMindCollectSetting.value = false;

        //本地先即時更新
        mindmapList.value = mindmapList.value.map((item) => {
            if (item.id === currentMindMap.value.id) {
                item.mindCollectName = data.mindCollectName;
                item.openSubmit = data.openSubmit;
                item.allowViewOthers = data.allowViewOthers;
            }
            return item;
        })

    } catch (error) {
        console.error("儲存失敗：", error);
    }

}
const confirmToUpdateMindCollectNormal = async () => {

    try {
        const data = {
            "cid": currentMindMap.value.id,
            "mindCollectName": renameMindCollectNormalVal.value.length !== 0 ? renameMindCollectNormalVal.value : currentMindCollectNormalName.value,
            "editor": {
                "id": profile.teammodelId,
                "name": profile.name,
            },
            "openSubmit": isMindCollectSubmitOpen.value,
            "allowViewOthers": isMindCollectAllowView.value,
        }
        await api.mindmapAPI.updateMindCollect(data);

        $Message.info(that.$t("mindmap.mindmapHome.saveOk"));
        showUpdateMindCollectNormalSetting.value = false;

        //本地先即時更新
        mindmapList.value = mindmapList.value.map((item) => {
            if (item.id === currentMindMap.value.id) {
                item.mindCollectName = data.mindCollectName;
                item.openSubmit = data.openSubmit;
                item.allowViewOthers = data.allowViewOthers;
            }
            return item;
        })

    } catch (error) {
        console.error("儲存失敗：", error);
    }

}





const confirmToCreateMindCollect = async () => {
    // 創建收集區
    const data = {
        "mindCollectName": renameMindCollectVal.value.length !== 0 ? renameMindCollectVal.value : currentMindCollectName.value,
        "creator": {
            "id": profile.teammodelId,
            "name": profile.name,

        },
        "openSubmit": isMindCollectSubmitOpen.value,
        "allowViewOthers": isMindCollectAllowView.value,
        "stopSubmitTime": 0,
        "collectType": "task"
    }
    const res = await api.mindmapAPI.createMindCollect(data);

    //獲取簡碼
    const currentMindCollectURL = `${location.origin}/mindcollect?cid=${res.id}`;

    const dataForClip = {
        "origDataList": [{ "origData": currentMindCollectURL }],
        "type": "mindmap",
        "useShortDigits": false,
        "isPermanent": false,
        "lang": that.$i18n.locale.toLowerCase(),
        "note": JSON.stringify({mindCollectName:data.mindCollectName})
    };

    const clipRes = await api.mindmapAPI.getClipCode(dataForClip);
    const clipCode = clipRes.clipCodePairs[0].clipCode;


    //儲存簡碼
    const uptData2 = {
        "cid": res.id,
        "mindCollectName": renameMindCollectVal.value.length !== 0 ? renameMindCollectVal.value : currentMindCollectName.value,
        "editor": {
            "id": profile.teammodelId,
            "name": profile.name,
        },
        "openSubmit": isMindCollectSubmitOpen.value,
        "allowViewOthers": isMindCollectAllowView.value,
        "urlClipCode": clipCode,

    }
    await api.mindmapAPI.updateMindCollect(uptData2);


    router.push({
        name: "MindCollect",
        query: {
            cid: res.id,
            showSetting: true
        }
    });
    console.log(res);
}

const confirmToCreateMindCollectNormal = async () => {

    // 創建收集區
    const data = {
        "mindCollectName": renameMindCollectNormalVal.value.length !== 0 ? renameMindCollectNormalVal.value : currentMindCollectNormalName.value,
        "creator": {
            "id": profile.teammodelId,
            "name": profile.name,

        },
        "openSubmit": isMindCollectSubmitOpen.value,
        "allowViewOthers": isMindCollectAllowView.value,
        "stopSubmitTime": 0,
        "collectType": "normal"
    }
    const res = await api.mindmapAPI.createMindCollect(data);

    //獲取簡碼
    const currentMindCollectURL = `${location.origin}/mindcollect_normal?cid=${res.id}`;

    const dataForClip = {
        "origDataList": [{ "origData": currentMindCollectURL }],
        "type": "mindmap",
        "useShortDigits": false,
        "isPermanent": false,
        "lang": that.$i18n.locale.toLowerCase(),
        "note": JSON.stringify({mindCollectNormalName:data.mindCollectName})
    };

    const clipRes = await api.mindmapAPI.getClipCode(dataForClip);
    const clipCode = clipRes.clipCodePairs[0].clipCode;


    //儲存簡碼
    const uptData2 = {
        "cid": res.id,
        "mindCollectName": renameMindCollectNormalVal.value.length !== 0 ? renameMindCollectNormalVal.value : currentMindCollectNormalName.value,
        "editor": {
            "id": profile.teammodelId,
            "name": profile.name,
        },
        "openSubmit": isMindCollectSubmitOpen.value,
        "allowViewOthers": isMindCollectAllowView.value,
        "urlClipCode": clipCode,
        "collectType": "normal"

    }
    await api.mindmapAPI.updateMindCollect(uptData2);


    router.push({
        name: "MindCollectNormal",
        query: {
            cid: res.id,
            showSetting: true
        }
    });
    console.log(res);
}

// 創建心智圖作業任務（以現有心智圖為範本）
const createMindCollectFromTemplate = async (mindMap) => {
    // 先斷開目前的 Fluid 連接
    if (fluidContainer && typeof fluidContainer.dispose === 'function') {
        fluidContainer.dispose();
    }
    
    $q.loading.show({
        message: that.$t("mindmap.mindmapHome.initialize")
    });
    
    try {
        
        // 1. 先創建範本心智圖，參考 createReferMindMap 格式
        let templateData = {
            "mindmapName": `${mindMap.mindmapName}_${that.$t("mindmap.mindmapHome.taskSuffix")}_${that.$t("mindmap.mindmapHome.template")}`,
            "mindmapCreator": {
                "id": profile.teammodelId,
                "name": profile.name,
            },
            "mindSubCreator": {
                "id": "0",
                "name": "teacher",
            },
            "collectId": "", // 稍後會設定
            "mindSubCreatorEditKey": "",
            "mindmapData": "",
            "fluidContainerId": "",
            "openCowork": false,
            "coworkMode": "view",
        };

        // 1. 先獲取原心智圖資料
        const copyMindData = await getFluidMindData(mindMap.fluidContainerId);
        
        // 2. 初始化 Azure 客戶端並創建新容器
        const client = await initializeAzureClient();
        const { container } = await client.createContainer(containerSchema, "2;");
        templateData.fluidContainerId = await container.attach();

        const fluidIsDeleting = container.initialObjects.isDeleting;
        const fluidCoworkMode = container.initialObjects.coworkMode;
        let fluidMindData = container.initialObjects.mindData;
        if (copyMindData) {
            for (const [key, value] of copyMindData) {
                fluidMindData.set(key, value);
            }
        }

        // 設定 Fluid 狀態
        fluidIsDeleting.set('data', false);
        fluidCoworkMode.set('data', JSON.stringify({
            "coworkMode": "edit",
            "openCowork": true,
        }));

        // 2. 先創建收集區
        const collectData = {
            "mindCollectName": `${mindMap.mindmapName}_${that.$t("mindmap.mindmapHome.taskSuffix")}`,
            "creator": {
                "id": profile.teammodelId,
                "name": profile.name,
            },
            "openSubmit": true,
            "allowViewOthers": true,
            "stopSubmitTime": 0,
            "collectType": "task"
        };

        const collectRes = await api.mindmapAPI.createMindCollect(collectData);
        
        // 3. 將收集區 ID 加入範本資料
        templateData.collectId = collectRes.id;

        // 4. 創建範本心智圖
        const templateRes = await api.mindmapAPI.createMindMap(templateData);

        // 5. 更新收集區，設定 collectReferMindId 和 useTemplate
        const updateCollectData = {
            "cid": collectRes.id,
            "collectReferMindId": templateRes.id,
            "useTemplate": true,
            "editor": {
                "id": profile.teammodelId,
                "name": profile.name,
            },
        };
        await api.mindmapAPI.updateMindCollect(updateCollectData);

        // 6. 獲取簡碼
        const currentMindCollectURL = `${location.origin}/mindcollect?cid=${collectRes.id}`;
        const dataForClip = {
            "origDataList": [{ "origData": currentMindCollectURL }],
            "type": "mindmap",
            "useShortDigits": false,
            "isPermanent": false,
            "lang": that.$i18n.locale.toLowerCase(),
            "note": JSON.stringify({mindCollectName: collectData.mindCollectName})
        };

        const clipRes = await api.mindmapAPI.getClipCode(dataForClip);
        const clipCode = clipRes.clipCodePairs[0].clipCode;

        // 7. 最終更新收集區簡碼
        await api.mindmapAPI.updateMindCollect({
            "cid": collectRes.id,
            "mindCollectName": collectData.mindCollectName,
            "editor": {
                "id": profile.teammodelId,
                "name": profile.name,
            },
            "openSubmit": collectData.openSubmit,
            "allowViewOthers": collectData.allowViewOthers,
            "urlClipCode": clipCode,
            "collectType": "task",
            "collectReferMindId": templateRes.id,
            "useTemplate": true
        });

        $q.loading.hide();
        $Message.success('心智圖作業任務創建成功！');
        
        // 8. 跳轉到收集區頁面
        router.push({
            name: "MindCollect",
            query: {
                cid: collectRes.id,
                showSetting: true
            }
        });

    } catch (error) {
        $q.loading.hide();
        console.error("創建心智圖作業任務失敗：", error);
        $Message.error('創建失敗，請稍後再試');
    }
    
    showActionMenu.value = false;
}

const mindMapStore = useMindMapStore();

const initMindMapBlob = () => {
    if (mindMapStore.mindMapBlobsasurl) {
        const serviceClient = new BlobServiceClient(
            mindMapStore.mindMapBlobsasurl + "?" + mindMapStore.mindMapBlobSas
        );
        const containerClient = serviceClient.getContainerClient("");
        mindMapStore.setMindMapBlobContainerClient(containerClient);
    }
}
const mindMapUploadFile = (currentFile, noTimeTitle = false) => {
    //跟konvaCanvasUploadFile 相同，之後要再細分資料夾
    let times = new Date().getTime();
    return new Promise((r, j) => {
        let promises = [];
        let targetfilename = noTimeTitle ? currentMindMap.value.id + "/" + currentFile.name : currentMindMap.value.id + "/" + times + currentFile.name;
        let blockBlobClient = mindMapStore.mindMapBlobContainerClient.getBlockBlobClient(targetfilename);
        promises.push(blockBlobClient.uploadBrowserData(currentFile));

        Promise.all(promises).then(
            () => {
                let finallink = mindMapStore.mindMapBlobsasurl + targetfilename;
                r({
                    url: finallink,
                    name: targetfilename,
                });
            },
            (err) => {
                j(err);
            }
        );
    });
}
const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
};

const replaceSingleImageSrc = async (topic) => {
    let container = document.createElement("div");
    container.innerHTML = topic; // 解析 HTML 字串

    let img = container.querySelector("img");
    if (img) {
        let file = dataURLtoFile(img.src, "a.png");
        let uploadedFile = await mindMapUploadFile(file);
        img.src = uploadedFile.url + "?" + mindMapStore.mindMapBlobSas; // 替換 src
    }

    return container.innerHTML; // 返回更新後的 HTML 字串
}

const uploadNodeImages = async (data) => {
    let uploadPromises = data.map(async (item) => {
        if (item.nodeImg) {
            let file = dataURLtoFile(item.nodeImg, "a.png"); // 轉 File
            let uploadedFile = await mindMapUploadFile(file); // 上傳 Azure Blob
            item.nodeImg = uploadedFile.url + "?" + mindMapStore.mindMapBlobSas; // 替換成 Azure Blob URL
            // 替換 <img> src
            if (item.topic && typeof item.topic === "string") {
                item.topic = await replaceSingleImageSrc(item.topic);
            }
        }
        return item;
    });

    return await Promise.all(uploadPromises);
}

const getMindMapSas = async () => {
    try {
        const res = await api.mindmapAPI.getMindMapSas();
        // 提取 token 并存储到 mindMapStore
        const { token, expiresOn } = res;
        mindMapStore.setMindMapBlobSas(token); // 存储 token

        sessionStorage.setItem("mindmap_sas_expiry", expiresOn.toString());

        initMindMapBlob();
    } catch (error) {
        console.error("Error fetching MindMap SAS:", error);
        // 可以根据需要添加更多错误处理逻辑
    }
}
const startTokenRefreshInterval = () => {
    tokenRefreshInterval.value = setInterval(async () => {

        //檢查auth_token是否即將過期
        const authExpiry = localStorage.getItem("auth_token_expiry");
        const now = Date.now();
        const refreshThreshold = 10 * 1000; // 提前 10 秒刷新

        if (authExpiry) {
            const exp = authExpiry * 1000; // 将 exp 转换为毫秒
            if (exp - now < refreshThreshold) {
                localStorage.removeItem("auth_token");
                localStorage.removeItem("auth_token_expiry");
                // console.log("Auth Token is about to expire. Refreshing...");
                await initializeAuth();
            }
        }

        const sasExpiry = sessionStorage.getItem("mindmap_sas_expiry");

        if (sasExpiry) {
            const sasExpiryMs = Date.parse(sasExpiry); // 将 ISO 格式时间解析为时间戳（毫秒）
            // console.log("Current Time:", now, "SAS Expiry Time:", sasExpiryMs);

            if (sasExpiryMs - now < refreshThreshold) {
                console.log("SAS Token is about to expire. Refreshing...");
                await getMindMapSas();
            }
        }
    }, 60 * 1000); // 每分检查一次
}

// const getMockFluidRelayEndpoint=async() => {
//     try {
//         const res = await api.mindmapAPI.getMockFluidRelayEndpoint();
//         return res
//     }catch (error) {
//         console.error('Error getMockFluidRelayEndpoint:', error);
//     }
// }
const clickHistoryItem = async (history) => {
    const type = history.type || 'MindMap';
    const mindmap = {
        id: history.id,
        type,
        mindmapName: history.mindmapName,
        snapshotUrl: history.snapshotUrl,
        mindmapCreator: history.mindmapCreator,
    };

    if (type === 'PublicMindMap') {
        saveEnterMindHistoryLocal(mindmap, 'PublicMindMap');
        trackView(mindmap, 'PublicMindMap');
        window.open(`/HTwbMind?loadPublic=true&publicId=${history.id}`, '_blank');
        return;
    }

    await saveEnterMindHistoryLocal(mindmap, 'MindMap');
    trackView(mindmap, 'MindMap');
    openMindMapByID(mindmap);
}

// 切換歷史記錄星號狀態
const toggleHistoryFavorite = async (history) => {
    try {
        const newFavoriteState = !history.isFavorite;
        
        // 立即更新本地狀態
        history.isFavorite = newFavoriteState;
        
        // 更新 localStorage
        updateHistoryInLocalStorage(history);
        
        // 呼叫 API 更新後端
        const response = await api.mindmapAPI.updateHistoryFavorite({
            tmid: profile.teammodelId,
            mindmapId: history.id,
            isFavorite: newFavoriteState
        });
        
        if (!response || response.error) {
            // API 失敗時復原本地狀態
            history.isFavorite = !newFavoriteState;
            updateHistoryInLocalStorage(history);
            console.error('更新星號狀態失敗');
        }
        
        // 更新分頁顯示
        updateHistoryPagination();
    } catch (error) {
        // 錯誤時復原本地狀態
        history.isFavorite = !history.isFavorite;
        updateHistoryInLocalStorage(history);
        updateHistoryPagination();
        console.error('切換星號狀態時發生錯誤:', error);
    }
}

// 更新 localStorage 中的歷史記錄
const updateHistoryInLocalStorage = (updatedHistory) => {
    const key = `enterMindHistory_${profile.teammodelId}`;
    const localHistories = JSON.parse(localStorage.getItem(key) || '[]');
    
    const index = localHistories.findIndex(h => h.id === updatedHistory.id);
    if (index !== -1) {
        localHistories[index] = { ...localHistories[index], isFavorite: updatedHistory.isFavorite };
        localStorage.setItem(key, JSON.stringify(localHistories));
    }
}

// 最近點閱分頁相關函數
const updateHistoryPagination = () => {
    // 根據篩選條件決定使用的資料源
    const sourceData = showOnlyFavorites.value 
        ? enterMindHistory.value.filter(h => h.isFavorite) 
        : enterMindHistory.value;
    
    filteredHistory.value = sourceData;
    const totalItems = sourceData.length;
    const totalPages = Math.ceil(totalItems / historyPageSize.value);
    
    // 更新分頁按鈕
    historyPageBtns.value = Array.from({ length: totalPages }, (_, index) => index + 1);
    
    // 確保當前頁碼不超過總頁數
    if (currentHistoryPageNum.value > totalPages) {
        currentHistoryPageNum.value = Math.max(1, totalPages);
    }
    
    // 計算當前頁顯示的資料
    const startIndex = (currentHistoryPageNum.value - 1) * historyPageSize.value;
    const endIndex = startIndex + historyPageSize.value;
    paginatedHistory.value = sourceData.slice(startIndex, endIndex);
}

const getHistoryByPage = (pageNum) => {
    currentHistoryPageNum.value = pageNum;
    updateHistoryPagination();
}

// 切換我的最愛篩選
const toggleFavoriteFilter = () => {
    showOnlyFavorites.value = !showOnlyFavorites.value;
    currentHistoryPageNum.value = 1; // 重置到第一頁
    updateHistoryPagination();
}

const clickMindItem = async (mindmap) => {
    if (mindmap.pk === "MindCollect" && mindmap.collectType === "task") {
        router.push({
            name: "MindCollect",
            query: {
                cid: mindmap.id,
            }
        });
    }
    else if (mindmap.pk === "MindCollect" && mindmap.collectType === "normal") {
        router.push({
            name: "MindCollectNormal",
            query: {
                cid: mindmap.id,
            }
        });
    } else {
        await saveEnterMindHistoryLocal(mindmap, 'MindMap');
        trackView(mindmap, 'MindMap');
        openMindMapByID(mindmap);
    }
}


const openMindMapByID = async (mindmap) => {


    const isFromHT = sessionStorage.getItem("jumpFrom") === "HT";

    if (isFromHT) {
        // console.log("isFromHT", toRaw(mindmap));
        if (!mindmap.openCowork && mindmap.coworkMode !== "edit") {
            try {
                $Message.info(that.$t("mindmap.mindmapHome.setCoworkInHTinfo"));
                // 將設定寫回 API
                await api.mindmapAPI.updateMindMap({
                    id: mindmap.id,
                    mindmapEditor: {
                        id: mindmap.mindmapEditor.id,
                        name: mindmap.mindmapEditor.name,
                    },
                    openCowork: true,
                    coworkMode: "edit",
                });

            } catch (error) {
                console.error("儲存失敗：", error);
            }
        }

    }
    router.push({
        path: '/MindMapClone',
        query: {
            id: mindmap.id
        }
    });
}
const openActionMenu = (mindmap, e) => {
    currentMindMap.value = mindmap;
    if (mindmap.pk == "MindCollect" && mindmap.collectType == "task") {
        showCollectActionMenu.value = true
        showCollectNormalActionMenu.value = false
        showActionMenu.value = false
    }
    else if (mindmap.pk == "MindCollect" && mindmap.collectType == "normal") {
        showCollectNormalActionMenu.value = true
        showCollectActionMenu.value = false
        showActionMenu.value = false
    }
    else {
        showCollectActionMenu.value = false
        showCollectNormalActionMenu.value = false
        showActionMenu.value = true
    }

    actionMenuPos.x = e.clientX - 120
    actionMenuPos.y = e.clientY - 10
    
    // 選單寬度約120px
    const menuWidth = 120;
    const windowWidth = window.innerWidth;
    
    // 避免超出左邊視窗
    if (actionMenuPos.x < 0) actionMenuPos.x = 30
    
    // 避免超出右邊視窗
    if (actionMenuPos.x + menuWidth > windowWidth) {
        actionMenuPos.x = windowWidth - menuWidth - 10;
    }
    
    // 根據選單類型估算選單高度
    let menuHeight = 245; // 一般心智圖選單（7個項目）
    if (mindmap.pk == "MindCollect") {
        menuHeight = 70; // 收集區選單（2個項目）
    }
    
    const windowHeight = window.innerHeight;
    // 避免超出底部視窗
    if (actionMenuPos.y + menuHeight > windowHeight) {
        actionMenuPos.y = windowHeight - menuHeight - 10;
    }
}

const openDetailInfo = () => {
    showDetailInfo.value = true
}
const closeDetailInfo = () => {
    showDetailInfo.value = false
}
const renameMindMap = () => {
    showRenameBox.value = true
    renameVal.value = currentMindMap.value.mindmapName
    console.log(currentMindMap.value)
}
const closeRenameBox = () => {
    showRenameBox.value = false
    renameVal.value = currentMindMap.value.mindmapName;
}

const loginTMID = () => {
    api.main.loginTmdID();
}

const goToPlayground = () => {
    router.push('/playground');
}

const logout = () => {
    showNavMenu.value = false
    if (isLogin.value) {
        api.main.logout().then(async () => {

            $Message.info(that.$t("mindmap.mindmapHome.logoutOK"));
            isLogin.value = false;
            store.setIsLogIn(false);
            localStorage.clear();
            sessionStorage.clear();
            // 登出後切換到 gallery 並重新載入公開心智圖
            currentView.value = 'gallery';
            loadPublicGallery(true);
        });
    }
}

const getMyMindMapList = async (data) => {
    try {
        const res = await api.mindmapAPI.getMindMapsByTmid(data);

        mindmapList.value.push(...res.data);
        pageBtns.value = Array.from({ length: res.totalPages }, (_, index) => index + 1);
        currentOpenFRUsage.value = res.fluidRelayUsage;

        isReachMaxOpenFRUsage.value = currentOpenFRUsage.value >= maxOpenFRUsage.value;
    } catch (error) {
        console.error('Error fetching mindmap list:', error);
    }
};

const getTime = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString();
}

const getFluidCoworkMode = async (Fid) => {
    try {

        const client = await initializeAzureClient();


        // 捕捉 getContainer 操作中的異常
        const result = await client.getContainer(Fid, containerSchema, "2");
        fluidContainer = result.container;
        const fluidCoworkMode = fluidContainer.initialObjects.coworkMode; //存放markdown資料
        return fluidCoworkMode;
    } catch (error) {
        console.error(error);
        $Message.error(that.$t("mindmap.cannotConnect"));
        return; // 如果無法獲取容器，直接退出
    }
};

const openShareLinkBox = async (mindmap) => {
    currentMindMap.value = mindmap;
    if (currentMindMap.value.openCowork) {
        currentMindMapURL.value = currentMindMap.value.urlClipCode
    }
    //打開時先將選單設為目前db狀態
    coworkModeSelect.value.currentSelect = currentMindMap.value.coworkMode === "view" ? that.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") : that.$t("mindmap.mindmapHome.coworkModeNoteText.editLongVer")
    showActionMenu.value = false
    showShareLinkBox.value = true

    localStorage.removeItem('cachedFluidRelayToken') //初始化先移除localStorage

    fluidCoworkMode = await getFluidCoworkMode(mindmap.fluidContainerId);
}

const setFluidCoworkMode = (data) => {
    fluidCoworkMode.set("data", data);
}

const deleteMindMap = async (mindmap) => {
    $q.loading.show({
        message: that.$t("mindmap.mindmapHome.deleting")
    });
    showComfirmDelete.value = false
    const containerId = mindmap.fluidContainerId

    //初始化先移除localStorage
    let container
    try {
        const client = await initializeAzureClient();

        // 捕捉 getContainer 操作中的異常
        const result = await client.getContainer(containerId, containerSchema, "2");
        container = result.container;
    } catch (error) {
        console.error(error);
        $Message.error(that.$t("mindmap.mindmapHome.cannotConnect"));
        return; // 如果無法獲取容器，直接退出
    }


    fluidIsDeleting = container.initialObjects.isDeleting; //是否處於殺除狀態
    fluidIsDeleting.set('data', true)
    //設置完就斷開
    if (container.isDirty) {
        container.once("saved", () => {
            container.dispose();
            container = null;
            localStorage.removeItem("cachedFluidRelayToken");
        });

    }
    container.on("disposed", () => {
        console.log("container已呼叫斷開!",)
    });

    try {
        await api.mindmapAPI.deleteMindMap({ id: mindmap.id });
        let data = {
            tmid: profile.teammodelId,
            pageSize: currentPageSize.value,
            pageNumber: currentPageNum.value,
            sortField: currentSortField.value,
            sortOrder: currentSortOrder.value
        }
        mindmapList.value = [];
        await getMyMindMapList(data);
        $q.loading.hide();
        $Message.info(that.$t("mindmap.mindmapHome.deletingOKinFront"));

    } catch (error) {
        console.error('Error deleting mindmap:', error);

    }
};
const getMyMindMapListByPage = async (page) => {
    currentPageNum.value = page
    let data = {
        tmid: profile.teammodelId,
        pageSize: currentPageSize.value,
        pageNumber: currentPageNum.value,
        sortField: currentSortField.value,
        sortOrder: currentSortOrder.value,
        searchText: search.value
    }
    mindmapList.value = [];
    $q.loading.show();
    await getMyMindMapList(data);
    $q.loading.hide();
};
const openComfirmDelete = (mindmap) => {
    currentMindMap.value = mindmap;
    showComfirmDelete.value = true
}
const closeComfirmDelete = () => {
    showComfirmDelete.value = false
}

const closeShareLinkBox = () => {
    showShareLinkBox.value = false
    setTimeout(() => {
        if (fluidContainer && typeof fluidContainer.dispose === 'function') {
            fluidContainer.dispose();
        }
    }, 200)
}
const saveCoworkMode = async () => {
    try {
        // 將設定寫回 API
        await api.mindmapAPI.updateMindMap({
            id: currentMindMap.value.id,
            mindmapEditor: {
                id: currentMindMap.value.mindmapEditor.id,
                name: currentMindMap.value.mindmapEditor.name,
            },
            coworkMode: coworkModeSelect.value.currentSelect === that.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") ? "view" : "edit",
        });
        currentMindMap.value.coworkMode = coworkModeSelect.value.currentSelect === that.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") ? "view" : "edit";

        let fluidCoworkModeData = JSON.stringify({
            "coworkMode": currentMindMap.value.coworkMode,
            "openCowork": currentMindMap.value.openCowork,
        });

        setFluidCoworkMode(fluidCoworkModeData);


        closeShareLinkBox();
        $Message.info(that.$t("mindmap.mindmapHome.saveOk"));
    } catch (error) {
        console.error("儲存失敗：", error);
    }
};

const setOpenCowork = async () => {
    try {
        currentMindMapURL.value = "";
        const origData = `${window.location.origin}/MindMapClone?id=${currentMindMap.value.id}`;
        currentMindMap.value.openCowork = true;

        let fluidCoworkModeData = JSON.stringify({
            "coworkMode": coworkModeSelect.value.currentSelect === that.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") ? "view" : "edit",
            "openCowork": true,
        });

        const data = {
            "origDataList": [{ "origData": origData }],
            "type": "mindmap",
            "useShortDigits": false,
            "isPermanent": false,
            "lang": that.$i18n.locale.toLowerCase(),
            "note": JSON.stringify({mindmapName:currentMindMap.value.mindmapName})
        };

        const res = await api.mindmapAPI.getClipCode(data);
        const clipCode = res.clipCodePairs[0].clipCode;

        // 將設定寫回API
        await api.mindmapAPI.updateMindMap({
            id: currentMindMap.value.id,
            mindmapEditor: {
                id: currentMindMap.value.mindmapEditor.id,
                name: currentMindMap.value.mindmapEditor.name,
            },
            openCowork: true,
            coworkMode: coworkModeSelect.value.currentSelect === that.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") ? "view" : "edit",
            urlClipCode: clipCode
        });
        //改顯示短網址
        currentMindMapURL.value = clipCode;
        setFluidCoworkMode(fluidCoworkModeData);
    } catch (error) {
        console.error("Error setting open cowork mode:", error);
    }
};

const closeOpenCowork = () => { //是否要斷開後續待側
    //將設定寫回api
    api.mindmapAPI.updateMindMap({
        id: currentMindMap.value.id,
        "mindmapEditor": {
            "id": currentMindMap.value.mindmapEditor.id,
            "name": currentMindMap.value.mindmapEditor.name,
        },
        openCowork: false,
    }).then((res) => {
        console.log(res);
        currentMindMap.value.openCowork = false;

        let fluidCoworkModeData = JSON.stringify({
            "coworkMode": coworkModeSelect.value.currentSelect === that.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") ? "view" : "edit",
            "openCowork": false,
        });

        setFluidCoworkMode(fluidCoworkModeData);

    })
}


const handleClickOutside = (event) => {
    if (!event.target.closest('.more-btn') && !event.target.closest('.actions')) {
        showActionMenu.value = false
        showCollectActionMenu.value = false
        showCollectNormalActionMenu.value = false
        showPublicActionMenu.value = false
    }
}
const handleNavClickOutside = (event) => {
    if (!event.target.closest('.nav-menu') && !event.target.closest('.avatar')) {
        showNavMenu.value = false
    }
    if (!event.target.closest('.add-box') && !event.target.closest('.add-btn-mid')) {
        showAddBox.value = false;
    }
    if (!event.target.closest('.side-add-box') && !event.target.closest('.add-btn')) {
        showSideAddBox.value = false;
    }
    if (!event.target.closest('.title-menu') && !event.target.closest('.mid-title-btn')) {
        showTitleMenu.value = false;
    }
}
const OpenAvatarMenu = () => {
    showNavMenu.value = !showNavMenu.value
    showAddBox.value = false
}
// 記錄已確認載入失敗的 snapshotUrl（reactive，觸發重繪）
const failedImgUrls = ref(new Set());
// 記錄正在測試中的 URL，避免重複發請求
const testingImgUrls = new Set();

const testImgUrl = (fullUrl, snapshotKey) => {
    if (!fullUrl || testingImgUrls.has(snapshotKey)) return;
    testingImgUrls.add(snapshotKey);
    const img = new Image();
    img.onerror = () => {
        failedImgUrls.value = new Set([...failedImgUrls.value, snapshotKey]);
    };
    img.src = fullUrl;
};

const generateMindMapPlaceholder = (seed = '') => {
    // xorshift seeded PRNG，讓同一張卡每次 render 結果一致
    let h = 0;
    for (let i = 0; i < seed.length; i++) {
        h = Math.imul(31, h) + seed.charCodeAt(i) | 0;
    }
    h = h || 12345;
    const rand = () => {
        h ^= h << 13; h ^= h >> 17; h ^= h << 5;
        return (h >>> 0) / 4294967296;
    };

    const W = 400, H = 280, cx = 200, cy = 140;
    const count = Math.floor(rand() * 6) + 1; // 1-6 個衛星節點
    let lines = '', circles = '';

    for (let i = 0; i < count; i++) {
        // 以均分角度為基底加入隨機偏移，避免節點重疊
        const baseAngle = (i / count) * Math.PI * 2;
        const angle = baseAngle + (rand() - 0.5) * 0.7;
        const dist = 65 + rand() * 15;
        const nx = Math.round(cx + Math.cos(angle) * dist);
        const ny = Math.round(cy + Math.sin(angle) * dist);
        lines += `<line x1="${cx}" y1="${cy}" x2="${nx}" y2="${ny}" stroke="white" stroke-width="2" stroke-linecap="round"/>`;
        circles += `<circle cx="${nx}" cy="${ny}" r="9" fill="white"/>`;
    }

    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${W}" height="${H}" viewBox="0 0 ${W} ${H}"><rect width="${W}" height="${H}" fill="#cbd5e1"/>${lines}${circles}<circle cx="${cx}" cy="${cy}" r="16" fill="white"/></svg>`;
    return `url("data:image/svg+xml;base64,${btoa(svg)}")`;
};

const getHistoryImg = (url) => {
    try {
        if (mindMapStore.mindMapBlobsasurl && mindMapStore.mindMapBlobSas && url) {
            if (failedImgUrls.value.has(url)) {
                return generateMindMapPlaceholder(url);
            }
            const fullUrl = mindMapStore.mindMapBlobsasurl + url + '?' + mindMapStore.mindMapBlobSas;
            testImgUrl(fullUrl, url);
            return `url("${fullUrl}")`;
        } else {
            return generateMindMapPlaceholder(url || '');
        }
    } catch (err) {
        console.error(err);
    }
};
const getMindMapImgUrl = (mindmap) => {
    try {
        if (mindMapStore.mindMapBlobsasurl && mindMapStore.mindMapBlobSas && mindmap?.snapshotUrl) {
            const key = mindmap.snapshotUrl;
            if (failedImgUrls.value.has(key)) {
                return generateMindMapPlaceholder(mindmap?.id || key);
            }
            const fullUrl = mindMapStore.mindMapBlobsasurl + key + '?' + mindMapStore.mindMapBlobSas;
            testImgUrl(fullUrl, key);
            return `url("${fullUrl}")`;
        } else {
            return generateMindMapPlaceholder(mindmap?.id || mindmap?.mindmapName || '');
        }
    } catch (err) {
        console.log(err);
    }
}
const setView = async (view) => {
    showTitleMenu.value = false
    currentPageNum.value = 1
    currentView.value = view
    search.value = ""

    // 切換到最近點閱時，重置分頁狀態
    if (view === 'recent') {
        currentHistoryPageNum.value = 1;
    }
    // 切換到公開展示時，重置分頁狀態
    if (view === 'public') {
        currentPublicPageNum.value = 1;
    }

    // 保存視圖偏好到 localStorage（排除 recent、public、gallery）
    if (isLogin.value && profile.teammodelId && !['recent', 'public', 'gallery'].includes(view)) {
        localStorage.setItem(`mindmap_view_preference_${profile.teammodelId}`, view)
    }

    if (view === 'gallery') {
        loadPublicGallery(true);
        return;
    }

    if (view == 'recent') {
        // 切換到最近點閱視圖時，立即從 localStorage 載入顯示（optimistic）
        loadHistoryFromLocalStorage();
        // 背景同步 API 資料（確保資料最新，修正 localStorage 被其他頁面截短的問題）
        loadMindClickHistory();
        return;
    }

    if (view == 'public') {
        await getMyPublicMindMapList(1);
        return;
    }
    let data = {
        tmid: profile.teammodelId,
        pageSize: currentPageSize.value,
        pageNumber: 1,
        sortField: currentSortField.value,
        sortOrder: currentSortOrder.value,
        searchText: search.value
    }
    mindmapList.value = [];
    $q.loading.show();
    await getMyMindMapList(data);
    $q.loading.hide();
}
const formatViewCount = (n) => {
    if (n >= 1000) { const k = Math.floor(n / 100) / 10; return (k % 1 === 0 ? k.toFixed(0) : k.toFixed(1)) + 'K'; }
    return n;
};

// Gallery 函數
const loadPublicGallery = async (reset = true) => {
    if (reset) {
        galleryPage.value = 1;
        galleryItems.value = [];
    }
    isGalleryLoading.value = true;
    try {
        const res = await api.mindmapAPI.getPublicMindMaps({
            search: gallerySearch.value,
            page: galleryPage.value,
            pageSize: 20
        });
        const items = res.items || [];
        galleryItems.value = reset ? items : [...galleryItems.value, ...items];
        cardColorSeq.value = genCardColors(galleryItems.value.length, reset ? [] : cardColorSeq.value);
        galleryHasMore.value = res.hasMore || false;
    } catch (e) {
        console.error('載入 Gallery 失敗:', e);
    } finally {
        isGalleryLoading.value = false;
    }
};
const searchGallery = () => { loadPublicGallery(true); };
const clearGallerySearch = () => { gallerySearch.value = ''; loadPublicGallery(true); };
const loadMoreGallery = () => { galleryPage.value++; loadPublicGallery(false); };

// 取得 DB 全量心智圖數（pk = 'MindMap'）
const loadMindMapTotalCount = async () => {
    try {
        const res = await api.mindmapAPI.getMindMapTotalCount();
        if (res?.total != null) galleryTotal.value = res.total;
    } catch (e) {
        console.error('載入心智圖總數失敗:', e);
    }
};
const getMyPublicMindMapList = async (page) => {
    currentPublicPageNum.value = page;
    $q.loading.show();
    try {
        const res = await api.mindmapAPI.getMyPublicMindMaps({
            tmid: profile.teammodelId,
            page: page,
            pageSize: publicPageSize.value
        });
        publicMindmapList.value = res.items || [];
        publicPageBtns.value = Array.from({ length: res.totalPages || 1 }, (_, i) => i + 1);
    } catch (e) {
        console.error('載入公開展示失敗:', e);
    } finally {
        $q.loading.hide();
    }
};
const getMyPublicMindMapListByPage = async (page) => {
    await getMyPublicMindMapList(page);
};
const openPublicMindMap = (item) => {
    window.open(`/HTwbMind?loadPublic=true&publicId=${item.id}`, '_blank');
};
const openPublicActionMenu = (item, e) => {
    currentPublicItem.value = item;
    showPublicActionMenu.value = true;
    showActionMenu.value = false;
    showCollectActionMenu.value = false;
    showCollectNormalActionMenu.value = false;
    actionMenuPos.x = e.clientX - 55;
    actionMenuPos.y = e.clientY - 10;
    if (actionMenuPos.x < 0) actionMenuPos.x = 10;
    if (actionMenuPos.x + 80 > window.innerWidth) actionMenuPos.x = window.innerWidth - 90;
};
const confirmDeletePublicMindMap = () => {
    showPublicActionMenu.value = false;
    if (!currentPublicItem.value) return;
    showConfirmDeletePublic.value = true;
};
const doDeletePublicMindMap = async () => {
    showConfirmDeletePublic.value = false;
    if (!currentPublicItem.value) return;
    $q.loading.show();
    try {
        await api.mindmapAPI.deletePublicMindMap({ publicMindMapId: currentPublicItem.value.id, tmid: profile.teammodelId });
        await getMyPublicMindMapList(currentPublicPageNum.value);
    } catch (e) {
        console.error('刪除公開心智圖失敗:', e);
    } finally {
        $q.loading.hide();
    }
};

const searchMindMaps = async () => {
    let data = {
        tmid: profile.teammodelId,
        pageSize: currentPageSize.value,
        pageNumber: 1,
        sortField: currentSortField.value,
        sortOrder: currentSortOrder.value,
        searchText: search.value
    }
    mindmapList.value = [];
    $q.loading.show();
    await getMyMindMapList(data)
    $q.loading.hide();
}
const resetSearch = async () => {
    search.value = ""
    mindmapList.value = []
    let data = {
        tmid: profile.teammodelId,
        pageSize: currentPageSize.value,
        pageNumber: 1,
        sortField: currentSortField.value,
        sortOrder: currentSortOrder.value
    }
    mindmapList.value = [];
    await getMyMindMapList(data)

}
const resetRename = () => {
    renameVal.value = currentMindMap.value.mindmapName;
}
const resetMindCollectName = () => {
    renameMindCollectVal.value = ""
}
const resetMindCollectNormalName = () => {
    renameMindCollectNormalVal.value = ""
}
const saveRename = async () => {
    try {
        // 將設定寫回 API
        await api.mindmapAPI.updateMindMap({
            mindmapName: renameVal.value,
            id: currentMindMap.value.id,
            mindmapEditor: {
                id: currentMindMap.value.mindmapEditor.id,
                name: currentMindMap.value.mindmapEditor.name,
            },

        });
        currentMindMap.value.mindmapName = renameVal.value;
        closeRenameBox();
        $Message.info(that.$t("mindmap.mindmapHome.saveOk"));
    } catch (error) {
        console.error("儲存失敗：", error);
    }
}
const loadMindClickHistory = async () => {
    const storageKey = `enterMindHistory_${profile.teammodelId}`;
    let histories = [];
    let apiHistories = [];
    
    historyLoadingState.value.loading = true;
    historyLoadingState.value.error = false;

    // 首先載入 localStorage 資料（優先顯示）
    histories = JSON.parse(localStorage.getItem(storageKey) || "[]");
    
    try {
        // 嘗試從 API 獲取資料（用於合併）
        const response = await api.mindmapAPI.getMindClickHistory({ tmid: profile.teammodelId });
        if (response && response.mindmapHistories) {
            // 補齊舊資料缺少的 type 欄位
            apiHistories = response.mindmapHistories.map(h => ({ type: 'MindMap', ...h }));
        }
    } catch (error) {
        console.error("Failed to load history from API:", error);
        historyLoadingState.value.error = true;
    }

    // 合併 localStorage 和 API 資料，以 localStorage 為主，但合併 isFavorite 狀態
    if (apiHistories.length > 0) {
        if (histories.length === 0) {
            // 如果localStorage為空，直接使用API資料，確保 isFavorite 正確設置
            histories = apiHistories.map(apiItem => ({
                ...apiItem,
                isFavorite: apiItem.isFavorite || false
            }));
        } else {
            // 建立一個 Map 來追蹤現有項目
            const existingHistoriesMap = new Map(histories.map(h => [h.id, h]));
            
            // 更新現有項目的 isFavorite 狀態（如果 API 有更新）
            histories = histories.map(localItem => {
                const apiItem = apiHistories.find(api => api.id === localItem.id);
                if (apiItem && apiItem.isFavorite !== undefined) {
                    return { ...localItem, isFavorite: apiItem.isFavorite };
                }
                return localItem;
            });
            
            // 將 API 中有但 localStorage 沒有的項目加入
            const newItems = apiHistories
                .filter(apiItem => !existingHistoriesMap.has(apiItem.id))
                .map(apiItem => ({
                    ...apiItem,
                    isFavorite: apiItem.isFavorite || false
                }));
            histories = histories.concat(newItems);
        }
    }
    histories.sort((a, b) => b.timestamp - a.timestamp); //按照時間由近到遠排序
    
    // 限制最多顯示 100 筆，優先保留有星號的項目
    if (histories.length > 100) {
        // 分離有星號和沒星號的項目
        const favoriteItems = histories.filter(h => h.isFavorite);
        const nonFavoriteItems = histories.filter(h => !h.isFavorite);
        
        // 計算需要保留的項目數量
        if (favoriteItems.length >= 100) {
            // 如果星號項目就超過 100 筆，只保留最新的 100 筆星號項目
            histories = favoriteItems.slice(0, 100);
        } else {
            // 保留所有星號項目，再從非星號項目中保留最新的項目湊滿 100 筆
            const remainingSlots = 100 - favoriteItems.length;
            const selectedNonFavorites = nonFavoriteItems.slice(0, remainingSlots);
            histories = [...favoriteItems, ...selectedNonFavorites];
            // 重新按時間排序
            histories.sort((a, b) => b.timestamp - a.timestamp);
        }
    }
    // 更新到 enterMindHistory
    enterMindHistory.value = [...histories];
    
    // 更新分頁
    updateHistoryPagination();
    
    // 當localStorage為空或合併後資料有變化時才回寫
    const originalLocalHistories = JSON.parse(localStorage.getItem(storageKey) || "[]");
    if (originalLocalHistories.length === 0 || histories.length > originalLocalHistories.length) {
        localStorage.setItem(storageKey, JSON.stringify(histories));
    }
    
    historyLoadingState.value.loading = false;
};

const loadHistoryFromLocalStorage = () => {
    const storageKey = `enterMindHistory_${profile.teammodelId}`;
    const raw = JSON.parse(localStorage.getItem(storageKey) || "[]");
    // 補齊舊資料缺少的 type 欄位
    const localHistories = raw.map(h => ({ type: 'MindMap', ...h }));
    enterMindHistory.value = [...localHistories];

    // 更新分頁
    updateHistoryPagination();
};

const initializeAuth = async () => {
    try {
        const res = await api.main.getTokenUnlogin();
        const exp = jwt_decode(res.auth_token).exp
        localStorage.setItem("auth_token", res.auth_token);
        localStorage.setItem("auth_token_expiry", exp);
       
    } catch (error) {
        console.error("Error fetching auth token ", error);
    }
}
const handleGlobalKeyDown = (event) => {
    if (event.key === "Enter" && document.activeElement.tagName === "INPUT") {
        searchMindMaps();
    }
};

const decryptData = (encryptedData, key) => {
    const decrypted = CryptoJS.AES.decrypt(decodeURIComponent(encryptedData), key);
    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
}
const resetShortUrlInput = () => {
    shortUrlInput.value = '';
};

const handleShortUrlEnter = () => {
    // 只有在未登入且有輸入內容時才執行
    if (!isLogin.value && shortUrlInput.value.length > 0) {
        openMindMapByShortUrl();
    }
};

const openMindMapByShortUrl = async () => {
    if (shortUrlInput.value) {
        try {
            let data = {
                clipCode: shortUrlInput.value
            }
            const res = await api.mindmapAPI.getOrigDataFromClipCode(data);
            window.location.href = res.origData;
        } catch (error) {
            $Message.error(that.$t("mindmap.mindmapHome.cannotOpenShortUrl"));
        }
    }
};

// 資料夾清單彈窗相關狀態
const showMoveToFolderModal = ref(false);
const folderList = ref([]);
const selectedFolderId = ref(null);
const currentMovingMindMap = ref(null);
const selectedFolder = ref(null);

const openMoveToFolder = async (currentMindMap) => {
    try {
        currentMovingMindMap.value = currentMindMap;
        const res = await api.mindmapAPI.getMindCollectNormalFoldersByTmid({ tmid: profile.teammodelId });
        folderList.value = res.data || [];
        showMoveToFolderModal.value = true;
    } catch (error) {
        console.error('獲取資料夾列表失敗:', error);
        $Message.error(that.$t("mindmap.獲取資料夾列表失敗"));
    }
};

const closeMoveToFolderModal = () => {
    showMoveToFolderModal.value = false;
    selectedFolderId.value = null;
    selectedFolder.value = null;
};

const selectFolder = (folder) => {
    selectedFolderId.value = folder.id;
    selectedFolder.value = folder;
};

const confirmMoveToFolder = async () => {
    
    try {
        await api.mindmapAPI.updateMindMap({
            id: currentMindMap.value.id,
            mindmapEditor: {
                id: profile.teammodelId,
                name: profile.name,
            },

            collectId: selectedFolderId.value,
            collectIdType: "normal",
        });
        // 暫時模擬成功
        $Message.success(that.$t("mindmap.mindmapHome.moveSuccess"));
       
       
        router.push({
            name: "MindCollectNormal",
            query: {
                cid: selectedFolderId.value,
            }
        });
    } catch (error) {
        console.error('移動失敗:', error);
        $Message.error(that.$t("mindmap.mindmapHome.moveFail"));
    }
}


onBeforeUnmount(() => {
    // 移除 postMessage 監聽器
    window.removeEventListener('message', handleParentMessage);

    document.removeEventListener('click', handleClickOutside);
    document.removeEventListener('click', handleNavClickOutside);
    document.removeEventListener("keydown", handleGlobalKeyDown);
});

// ========== 雲心智圖：監聽路由變化並回報給父視窗（用於翻頁記憶） ==========
/**
 * 發送 URL 變化通知給父視窗
 */
const notifyUrlChange = (url) => {
    const isInIframe = window.self !== window.top;
    if (!isInIframe) return;

    const message = {
        action: 'MindMap.UrlChanged',
        url: url,
        fullUrl: window.location.href
    };

    console.log('[MindMap] 發送 URL 變化通知:', url);
    console.log('[MindMap] 發送協議:', message);
    window.parent.postMessage(message, '*');
};

/**
 * 監聽路由變化
 */
watch(() => route.fullPath, (newPath, oldPath) => {
    if (newPath !== oldPath) {
        console.log('[MindMap] 路由變化:', oldPath, '→', newPath);
        notifyUrlChange(newPath);
    }
}, { immediate: false });
// ========== 雲心智圖：路由監聽結束 ==========

/** 處理語系切換 */
const handleLanguageSwitch = (languageParam) => {
    if (!languageParam) return;
    
    // 語系對應邏輯
    let targetLocale = null;
    const lowerParam = languageParam.toLowerCase();
    
    if (lowerParam === 'en' || lowerParam === 'en-us') {
        targetLocale = 'en-US';
    } else if (lowerParam === 'zh-cn') {
        targetLocale = 'zh-CN';
    } else if (lowerParam === 'zh-tw') {
        targetLocale = 'zh-TW';
    } else if (!lowerParam.startsWith('zh')) {
        // 非中文的其他語系都切換到英文
        targetLocale = 'en-US';
    }
    
    if (targetLocale) {
        // 切換 Vue i18n 語系
        i18n.global.locale = targetLocale;
        localStorage.setItem('local', targetLocale);
    }
}

onMounted(async () => {
    // ========== 新增: iframe postMessage 登入機制 ==========
    const isInIframe = window.self !== window.top;

    if (isInIframe) {
        console.log('[MindMap] 偵測到在 iframe 中運行，啟用 postMessage 登入');

        // 監聽來自父視窗的認證訊息
        window.addEventListener('message', handleParentMessage);

        // 延遲 100ms 後通知父視窗準備完成
        setTimeout(() => {
            console.log('[MindMap] 發送 MindMap.Ready 給父視窗');
            window.parent.postMessage({ action: 'MindMap.Ready' }, '*');
        }, 100);

        // 延遲 200ms 後發送當前 URL（用於翻頁記憶）
        setTimeout(() => {
            const currentUrl = route.fullPath;
            const message = {
                action: 'MindMap.UrlChanged',
                url: currentUrl,
                fullUrl: window.location.href
            };
            console.log('[MindMap] 組件掛載，發送當前 URL:', currentUrl);
            console.log('[MindMap] 發送協議:', message);
            window.parent.postMessage(message, '*');
        }, 200);
    }
    // ========== 新增結束 ==========

    // 處理 URL 參數中的語系切換
    const languageParam = route.query.l;
    if (languageParam) {
        handleLanguageSwitch(String(languageParam));
        // 移除 URL 中的 l 參數
        const url = new URL(window.location.href);
        url.searchParams.delete('l');
        window.history.replaceState({}, document.title, url.toString());
    }

    try {
        await initializeAuth();
    } catch (error) {
        console.error("Error fetching auth token or mind map SAS:", error);
    }
    //初始化
    $q.loading.show();
    await getMindMapSas();
    startTokenRefreshInterval(); // 啟用檢查機制

    $q.loading.hide();
    document.addEventListener('click', handleClickOutside);
    document.addEventListener('click', handleNavClickOutside);
    document.addEventListener("keydown", handleGlobalKeyDown);

    // 不論登入與否，都先背景載入 gallery
    loadPublicGallery(true);
    loadMindMapTotalCount();

    // 優先檢查 URL 中是否有 code 參數
    let url = new URL(window.location.href);
    let code = url.searchParams.has("code") == true ? url.searchParams.get("code") : "";

    if (code) {
        localStorage.removeItem("access_token");
        localStorage.removeItem("expires_in");
        localStorage.removeItem("profile");
        //登入取得token
        api.main
            .getToken()
            .then(async (res) => {
                localStorage.setItem("id_token", res.id_token);
                const decoded = jwt_decode(res.id_token);

                isLogin.value = true;
                store.setIsLogIn(true);
                profile.name = decoded.name;
                profile.teammodelId = decoded.sub;
                profile.picture = decoded.picture;

                //將access_token存本地, http 攔截器使用
                localStorage.setItem("access_token", res.access_token);
                localStorage.setItem("expires_in", res.expires_in);

                localStorage.setItem(
                    "profile",
                    JSON.stringify({
                        name: profile.name,
                        id: profile.teammodelId,
                        picture: profile.picture,
                    })
                );
                
                // 從 localStorage 讀取用戶視圖偏好
                const savedView = localStorage.getItem(`mindmap_view_preference_${profile.teammodelId}`);
                if (savedView) {
                    currentView.value = savedView;
                }
                
                let data = {
                    tmid: profile.teammodelId,
                    pageSize: currentPageSize.value,
                    pageNumber: 1,
                    sortField: currentSortField.value,
                    sortOrder: currentSortOrder.value
                }
                $q.loading.show();
                
                // 只有在最近點閱視圖才載入歷史記錄
                if (currentView.value === 'recent') {
                    loadHistoryFromLocalStorage();
                    loadMindClickHistory();
                }
                
                await getMyMindMapList(data);
                $q.loading.hide();

                const url = new URL(window.location.href);
                url.searchParams.delete('code');
                url.searchParams.delete('state');
                url.searchParams.delete('clientId');
                window.history.replaceState({}, document.title, url.toString());

                await handlePendingAction();
            })
            .catch((err) => {
                console.log(err);
            });
    }
    else if (localStorage.getItem("profile") && localStorage.getItem("access_token")) {
        isLogin.value = true;
        let localeProfile = JSON.parse(localStorage.getItem("profile"));
        profile.name = localeProfile.name;
        profile.teammodelId = localeProfile.id || localeProfile.teammodelId;
        profile.picture = localeProfile.picture;

        // 從 localStorage 讀取用戶視圖偏好
        const savedView = localStorage.getItem(`mindmap_view_preference_${profile.teammodelId}`);
        if (savedView) {
            currentView.value = savedView;
        }
        
        // 只有在最近點閱視圖才載入歷史記錄
        if (currentView.value === 'recent') {
            // 立即載入 localStorage 資料
            loadHistoryFromLocalStorage();
            // 背景同步 API 資料
            loadMindClickHistory();
        }

        let data = {
            tmid: profile.teammodelId,
            pageSize: currentPageSize.value,
            pageNumber: currentPageNum.value,
            sortField: currentSortField.value,
            sortOrder: currentSortOrder.value
        }
        $q.loading.show();
        await getMyMindMapList(data);
        $q.loading.hide();

        // 檢查是否有公開展示白名單權限
        try {
            const accessRes = await api.mindmapAPI.checkPublicFeatureAccess({ tmid: profile.teammodelId });
            canUsePublicDisplay.value = accessRes?.allowed ?? false;
        } catch {
            canUsePublicDisplay.value = false;
        }

        await handlePendingAction();
    } else {
        // 未登入：預設顯示 gallery
        currentView.value = 'gallery';
    }

    // 若 URL 帶有 ?view=gallery，強制切換到 gallery（覆蓋 savedView）
    if (route.query.view === 'gallery') {
        currentView.value = 'gallery';
        const url = new URL(window.location.href);
        url.searchParams.delete('view');
        window.history.replaceState({}, document.title, url.toString());
    }
})

</script>
<style lang="less">
@import "../assets/color.less";

.mindmap-home {
    .select-btn {
        &:focus {
            --tw-ring-color: @light-color !important;
        }

        .arrow-icon-up {
            color: @light-color !important;
        }
    }
}
</style>
<style lang="less" scoped>
@import "../assets/color.less";
@import "../assets/mindmapHome.less";
</style>